/* eslint:disable */
/* This is autogenerated file, DO NOT add anything manually. Run "npm run generate" to generate types. */
/* Types are generated according to schema.ts located in manage-api. */

type Maybe<T> = T | null
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string
    String: string
    Boolean: boolean
    Int: number
    Float: number
    /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
    JSON: any
    /** The `Upload` scalar type represents a file upload. */
    Upload: any
}

export type AccountConsoleSettingsSave = {
    name?: Maybe<Scalars["String"]>
    importance: Scalars["Int"]
}

export type ActiveCardsRequestData = {
    state?: Maybe<Array<CardProgramCardState>>
    cardProgramId?: Maybe<Scalars["String"]>
    search?: Maybe<Scalars["String"]>
    locationIds?: Maybe<Array<Scalars["String"]>>
    offset?: Maybe<Scalars["Int"]>
    limit?: Maybe<Scalars["Int"]>
    sortBy?: Maybe<CardProgramCardSortField>
    sortDirection?: Maybe<SortDirection>
    depleted?: Maybe<Scalars["Boolean"]>
}

export type ActiveCardsResponseData = {
    content: Array<CardProgramCard>
    totalCount: Scalars["Int"]
}

export type AddedToItem = {
    id: Scalars["String"]
    name: Scalars["String"]
    icon?: Maybe<Scalars["Int"]>
    color?: Maybe<Scalars["String"]>
}

export type AggregatorConfig = {
    uber?: Maybe<UberStore>
    email?: Maybe<AggregatorEmailConfig>
    grubhub?: Maybe<AggregatorEmailConfig>
    doordash?: Maybe<AggregatorEmailConfig>
    slice?: Maybe<AggregatorEmailConfig>
    figure?: Maybe<FoodmeowStoreConfig>
    westSideEats?: Maybe<WestSideEatsConfig>
    type?: Maybe<AggregatorType>
}

export type AggregatorConfigRequestData = {
    figure?: Maybe<AggregatorFigureConfigRequestData>
    westSideEats?: Maybe<AggregatorWestSideEatsConfigRequestData>
    uber?: Maybe<AggregatorUberConfigRequestData>
    email?: Maybe<AggregatorEmailConfigRequestData>
    grubhub?: Maybe<AggregatorEmailConfigRequestData>
    doordash?: Maybe<AggregatorEmailConfigRequestData>
    slice?: Maybe<AggregatorEmailConfigRequestData>
    type?: Maybe<AggregatorType>
}

export type AggregatorEmailConfig = {
    address: Scalars["String"]
}

export type AggregatorEmailConfigRequestData = {
    address: Scalars["String"]
}

export type AggregatorFigureConfigRequestData = {
    description?: Maybe<Scalars["String"]>
    logo?: Maybe<Scalars["String"]>
    images?: Maybe<Array<Scalars["String"]>>
}

export enum AggregatorType {
    Grubhub = "grubhub",
    Uber = "uber",
    Doordash = "doordash",
    Slice = "slice",
    Mailgun = "mailgun",
    Figure = "figure",
    Westsideeats = "westsideeats",
    Email = "email",
}

export type AggregatorUberConfigRequestData = {
    storeId: Scalars["String"]
    name: Scalars["String"]
}

export type AggregatorWestSideEatsConfigRequestData = {
    apiKey: Scalars["String"]
}

export type Assignment = {
    id: Scalars["String"]
    name: Scalars["String"]
    parentId?: Maybe<Scalars["String"]>
    type?: Maybe<Scalars["String"]>
    showAsQuickFilter: Scalars["Boolean"]
    sortIndex: Scalars["Int"]
    locationId: Scalars["String"]
    config?: Maybe<AssignmentConfig>
    children?: Maybe<Array<Assignment>>
}

export type AssignmentAddUpdateRequestData = {
    id: Scalars["String"]
    name: Scalars["String"]
    parentId?: Maybe<Scalars["String"]>
    sortIndex?: Maybe<Scalars["Int"]>
    locationId: Scalars["String"]
    showAsQuickFilter: Scalars["Boolean"]
    config?: Maybe<AssignmentConfigRequestData>
}

export type AssignmentConfig = {
    customerRequired?: Maybe<Scalars["Boolean"]>
    guestCountRequired?: Maybe<Scalars["Boolean"]>
    deliveryAddressRequired?: Maybe<Scalars["Boolean"]>
    receiptHighlight?: Maybe<Scalars["Boolean"]>
    multipleSessions?: Maybe<Scalars["Boolean"]>
    allowTableOpenOrders?: Maybe<Scalars["Boolean"]>
    promptSeating?: Maybe<Scalars["Boolean"]>
    sendSmsOnOrderReady?: Maybe<Scalars["Boolean"]>
    orderReadyMessage?: Maybe<Scalars["String"]>
}

export type AssignmentConfigRequestData = {
    customerRequired?: Maybe<Scalars["Boolean"]>
    guestCountRequired?: Maybe<Scalars["Boolean"]>
    deliveryAddressRequired?: Maybe<Scalars["Boolean"]>
    receiptHighlight?: Maybe<Scalars["Boolean"]>
    multipleSessions?: Maybe<Scalars["Boolean"]>
    allowTableOpenOrders?: Maybe<Scalars["Boolean"]>
    promptSeating?: Maybe<Scalars["Boolean"]>
    sendSmsOnOrderReady?: Maybe<Scalars["Boolean"]>
    orderReadyMessage?: Maybe<Scalars["String"]>
}

export type AuditData = {
    ip?: Maybe<Scalars["String"]>
    webappPath?: Maybe<Scalars["String"]>
    batchId?: Maybe<Scalars["String"]>
    editorUserAccountId?: Maybe<Scalars["String"]>
}

export type AuthAccount = {
    id: Scalars["String"]
    name: Scalars["String"]
    userAccountId?: Maybe<Scalars["String"]>
}

export type AuthAccount2 = {
    id: Scalars["String"]
    name: Scalars["String"]
    typeOfBusiness?: Maybe<Scalars["String"]>
    slug: Scalars["String"]
    domainName?: Maybe<Scalars["String"]>
    importance?: Maybe<Scalars["Int"]>
    organizationId?: Maybe<Scalars["String"]>
    userAccountId?: Maybe<Scalars["String"]>
}

export type AuthLocation = {
    id: Scalars["String"]
    name: Scalars["String"]
    timezone: Scalars["String"]
    terminals: Array<AuthTerminal>
}

export type AuthLocationsResponse = {
    locations: Array<AuthLocation>
    masterListAccess: Scalars["Boolean"]
}

export type AuthOrganization = {
    id: Scalars["String"]
    name: Scalars["String"]
    type: Scalars["String"]
    originTimestamp?: Maybe<Scalars["String"]>
    lastUpdateTimestamp?: Maybe<Scalars["String"]>
    importance?: Maybe<Scalars["Int"]>
    userAccountId?: Maybe<Scalars["String"]>
}

export type AuthOrganizationUser = {
    id: Scalars["String"]
    organizationId: Scalars["String"]
    userId: Scalars["String"]
    firstName: Scalars["String"]
    middleName?: Maybe<Scalars["String"]>
    lastName: Scalars["String"]
    email?: Maybe<Scalars["String"]>
    phoneNumber?: Maybe<Scalars["String"]>
    isActive?: Maybe<Scalars["Boolean"]>
    deleted?: Maybe<Scalars["Boolean"]>
    createdTimestamp?: Maybe<Scalars["String"]>
    lastUpdateTimestamp?: Maybe<Scalars["String"]>
}

export type AuthTerminal = {
    id: Scalars["String"]
    locationId: Scalars["String"]
    name: Scalars["String"]
    type: TerminalType
    isActive?: Maybe<Scalars["Boolean"]>
    prefix?: Maybe<Scalars["String"]>
    url?: Maybe<Scalars["String"]>
    aggregatorConfig?: Maybe<AggregatorConfig>
    aggregatorType?: Maybe<AggregatorType>
    metadata?: Maybe<ServiceMetadata>
    appVersion?: Maybe<Scalars["String"]>
}

export enum CacheControlScope {
    Public = "PUBLIC",
    Private = "PRIVATE",
}

export type CardProgram = {
    id: Scalars["String"]
    name: Scalars["String"]
    expiration?: Maybe<Scalars["Int"]>
    type: CardProgramType
    timestampCreated: Scalars["String"]
    activatedOn?: Maybe<Array<CardProgramActivatedOn>>
    cardProgramBatches?: Maybe<Array<CardProgramBatch>>
}

export type CardProgramActivatedOn = {
    locationId: Scalars["String"]
    source: CardProgramSource
}

export type CardProgramBatch = {
    id: Scalars["String"]
    numberOfCards: Scalars["Int"]
    frontImagePath?: Maybe<Scalars["String"]>
    backImagePath?: Maybe<Scalars["String"]>
}

export type CardProgramBatchInput = {
    id?: Maybe<Scalars["String"]>
    numberOfCards?: Maybe<Scalars["Int"]>
    frontImagePath?: Maybe<Scalars["String"]>
    backImagePath?: Maybe<Scalars["String"]>
}

export type CardProgramCard = {
    id: Scalars["String"]
    key: Scalars["String"]
    type: CardProgramType
    state: CardProgramCardState
    timestampCreated: Scalars["String"]
    timestampActivated?: Maybe<Scalars["String"]>
    activationInfo?: Maybe<CardProgramCardActivationInfo>
    timestampExpiration?: Maybe<Scalars["String"]>
    timestampLastUsage?: Maybe<Scalars["String"]>
    valueOriginal?: Maybe<Scalars["Int"]>
    valueRemaining?: Maybe<Scalars["Int"]>
    programId?: Maybe<Scalars["String"]>
    programName?: Maybe<Scalars["String"]>
}

export type CardProgramCardActivationInfo = {
    timestamp?: Maybe<Scalars["String"]>
    locationId?: Maybe<Scalars["String"]>
    locationName?: Maybe<Scalars["String"]>
    terminalId?: Maybe<Scalars["String"]>
    terminalName?: Maybe<Scalars["String"]>
}

export type CardProgramCardResendEmailData = {
    locationId: Scalars["String"]
    cardId: Scalars["String"]
    email: Scalars["String"]
}

export enum CardProgramCardState {
    New = "new",
    Active = "active",
    Disabled = "disabled",
    Inactive = "inactive",
    Depleted = "depleted",
}

export enum CardProgramCardSortField {
    Key = "key",
    State = "state",
    TimestampCreated = "timestampCreated",
    TimestampActivated = "timestampActivated",
    TimestampExpiration = "timestampExpiration",
    TimestampLastUsage = "timestampLastUsage",
    ValueOriginal = "valueOriginal",
    ValueRemaining = "valueRemaining",
}

export enum SortDirection {
    Asc = "asc",
    Desc = "desc",
}

export type CardProgramSaveRequestActivatedOn = {
    locationId: Scalars["String"]
    source: CardProgramSource
}

export type CardProgramSaveRequestData = {
    id: Scalars["String"]
    name: Scalars["String"]
    type: CardProgramType
    expiration: Scalars["Int"]
    activatedOn?: Maybe<Array<CardProgramSaveRequestActivatedOn>>
    cardProgramBatches?: Maybe<Array<CardProgramBatchInput>>
}

export enum CardProgramSource {
    Pos = "pos",
    Mib = "mib",
    Kiosk = "kiosk",
}

export enum CardProgramType {
    Prepaid = "prepaid",
}

export type CashPaymentSettingsSaveRequest = {
    cashPaymentsEnabled?: Maybe<Scalars["Boolean"]>
    orderListOptionsEnabled?: Maybe<Scalars["Boolean"]>
    defaultCashRegisterBalance?: Maybe<Scalars["Int"]>
    openCashDrawerUponCardTip?: Maybe<Scalars["Boolean"]>
    cashDiscountEnabled?: Maybe<Scalars["Boolean"]>
    value?: Maybe<Scalars["Int"]>
    type?: Maybe<Scalars["String"]>
    autoApplyPOS?: Maybe<Scalars["Boolean"]>
    autoApplyMiB?: Maybe<Scalars["Boolean"]>
    autoApplyKiosk?: Maybe<Scalars["Boolean"]>
}

export type CashReportItem = {
    accountName?: Maybe<Scalars["String"]>
    amount: Scalars["Int"]
    assigneeName?: Maybe<Scalars["String"]>
    currency?: Maybe<Scalars["String"]>
    endBalance: Scalars["Int"]
    locationName?: Maybe<Scalars["String"]>
    orderNumber?: Maybe<Scalars["String"]>
    payInPayOut?: Maybe<Scalars["String"]>
    receivedOn: Scalars["String"]
    terminalName?: Maybe<Scalars["String"]>
    transactionNumber: Scalars["String"]
    transactionType?: Maybe<Scalars["String"]>
    operation?: Maybe<Scalars["String"]>
}

export type CashReportRequestData = {
    from: Scalars["String"]
    to: Scalars["String"]
    location_ids?: Maybe<Scalars["String"]>
    sort?: Maybe<Scalars["String"]>
    sort_order?: Maybe<Scalars["String"]>
    direction?: Maybe<Scalars["String"]>
    operation?: Maybe<Scalars["String"]>
    offset?: Maybe<Scalars["Int"]>
    count?: Maybe<Scalars["Int"]>
    timezone?: Maybe<Scalars["String"]>
}

export type CashReportResponse = {
    data: Array<CashReportItem>
    totalCount: Scalars["Int"]
}

export type CategoriesListItem = {
    id: Scalars["String"]
    name: Scalars["String"]
    displayName?: Maybe<Scalars["String"]>
    description?: Maybe<Scalars["String"]>
    parentId?: Maybe<Scalars["String"]>
    type: CategoryType
    pricingType?: Maybe<CategoryPricingType>
    isActive?: Maybe<Scalars["Boolean"]>
    icon?: Maybe<Scalars["Int"]>
    color?: Maybe<Scalars["String"]>
    price?: Maybe<Array<Scalars["Int"]>>
    unit?: Maybe<Scalars["String"]>
    cardProgramId?: Maybe<Scalars["String"]>
    tileImagePath?: Maybe<Scalars["String"]>
    displayImagePOS: Scalars["Boolean"]
    children?: Maybe<Array<CategoriesListItem>>
}

export type CategoriesListItemOverride = {
    locationId: Scalars["String"]
    data: CategoriesListItemOverrideData
}

export type CategoriesListItemOverrideData = {
    id: Scalars["String"]
    isActive?: Maybe<Scalars["Boolean"]>
    price?: Maybe<Array<Scalars["Int"]>>
}

export type CategoriesListResponse = {
    data: Array<CategoriesListItem>
    overrides: Array<CategoriesListItemOverride>
}

export type CategoryDetailData = {
    id: Scalars["String"]
    name: Scalars["String"]
    kitchenName?: Maybe<Scalars["String"]>
    alternativeNames?: Maybe<Array<Scalars["String"]>>
    tags?: Maybe<Array<Scalars["String"]>>
    type: Scalars["String"]
    isActive: Scalars["Boolean"]
    icon?: Maybe<Scalars["Int"]>
    color?: Maybe<Scalars["String"]>
    displayName?: Maybe<Scalars["String"]>
    internalName?: Maybe<Scalars["String"]>
    description?: Maybe<Scalars["String"]>
    taxes: Array<CategoryTax>
    pricings: Array<CategoryPricing>
    parentId?: Maybe<Scalars["String"]>
    fixedPrice?: Maybe<Scalars["Int"]>
    unit?: Maybe<Scalars["String"]>
    tare?: Maybe<Scalars["Int"]>
    pieces?: Maybe<Scalars["Int"]>
    disableItemNoteKiosk: Scalars["Boolean"]
    disableItemNoteMiB: Scalars["Boolean"]
    itemNoteMiBPlaceholder?: Maybe<Scalars["String"]>
    requireItemNoteMiB: Scalars["Boolean"]
    adjustablePricePOS: Scalars["Boolean"]
    displayImagePOS: Scalars["Boolean"]
    optionGroup?: Maybe<InItemOptionGroup>
    cardProgramId?: Maybe<Scalars["String"]>
    containsAlcohol?: Maybe<Scalars["Boolean"]>
    alwaysOpenPopover?: Maybe<Scalars["Boolean"]>
    modifierGroups: Array<InItemModifierGroup>
    images?: Maybe<Array<CategoryDetailDataImage>>
    minQuantity?: Maybe<Scalars["Int"]>
    maxQuantity?: Maybe<Scalars["Int"]>
    config?: Maybe<CategoryDetailDataConfig>
    barcode?: Maybe<Scalars["String"]>
    pluCode?: Maybe<Scalars["String"]>
}

export type CategoryDetailDataConfig = {
    mib?: Maybe<Scalars["JSON"]>
    kiosk?: Maybe<Scalars["JSON"]>
    pos?: Maybe<Scalars["JSON"]>
}

export type CategoryDetailDataImage = {
    id: Scalars["String"]
    path: Scalars["String"]
    type?: Maybe<CategoryDetailImageType>
    variants?: Maybe<Array<CategoryImageVariantDto>>
}

export enum CategoryDetailImageType {
    Normal = "normal",
}

export type CategoryDetailOverride = {
    locationId: Scalars["String"]
    data: CategoryDetailOverrideData
}

export type CategoryDetailOverrideData = {
    id: Scalars["String"]
    price?: Maybe<Array<Scalars["Int"]>>
    isActive?: Maybe<Scalars["Boolean"]>
    taxes?: Maybe<Array<CategoryTaxOverride>>
    pricings?: Maybe<Array<CategoryPricingOverride>>
    options?: Maybe<Array<InItemOptionOverride>>
    modifiers?: Maybe<Array<InItemModifierOverride>>
}

export type CategoryDetailResponse = {
    data: CategoryDetailData
    overrides: Array<CategoryDetailOverride>
    overridesV2: Array<Override>
}

export type CategoryImageVariantDto = {
    id: Scalars["String"]
    url: Scalars["String"]
    croppedType: Scalars["String"]
    cropCoords: CropCoords
}

export type CategoryModifier = {
    id: Scalars["String"]
    name: Scalars["String"]
    isActive: Scalars["Boolean"]
    kitchenName?: Maybe<Scalars["String"]>
    addedToGroups: Array<ModifierInGroup>
}

export type CategoryModifierGroup = {
    id: Scalars["String"]
    name: Scalars["String"]
    displayName?: Maybe<Scalars["String"]>
    price: Array<Scalars["Int"]>
    displayType: Scalars["String"]
    isActive: Scalars["Boolean"]
    isActivePOS?: Maybe<Scalars["Boolean"]>
    isActiveMIB?: Maybe<Scalars["Boolean"]>
    isActiveKiosk?: Maybe<Scalars["Boolean"]>
    isExclusion: Scalars["Boolean"]
    min?: Maybe<Scalars["Int"]>
    max?: Maybe<Scalars["Int"]>
    free?: Maybe<Scalars["Int"]>
    groupPrice?: Maybe<Scalars["Int"]>
    modifiers: Array<ModifierGroupItem>
    addedToItems: Array<AddedToItem>
}

export type CategoryModifierGroupOverride = {
    locationId: Scalars["String"]
    data: CategoryModifierGroupOverrideData
}

export type CategoryModifierGroupOverrideData = {
    id: Scalars["String"]
    price?: Maybe<Array<Scalars["Int"]>>
    isActive?: Maybe<Scalars["Boolean"]>
    min?: Maybe<Scalars["Int"]>
    max?: Maybe<Scalars["Int"]>
    free?: Maybe<Scalars["Int"]>
    groupPrice?: Maybe<Scalars["Int"]>
    modifiers: Array<ModifierGroupItemOverride>
}

export type CategoryModifierGroupResponse = {
    data: Array<CategoryModifierGroup>
    overrides: Array<CategoryModifierGroupOverride>
}

export type CategoryModifierOverride = {
    locationId: Scalars["String"]
    data: CategoryModifierOverrideData
}

export type CategoryModifierOverrideData = {
    id: Scalars["String"]
    isActive?: Maybe<Scalars["Boolean"]>
    addedToGroups: Array<ModifierGroupItemOverride>
}

export type CategoryModifierResponse = {
    data: Array<CategoryModifier>
    overrides: Array<CategoryModifierOverride>
}

export type CategoryOption = {
    id: Scalars["String"]
    categoryId: Scalars["String"]
    name: Scalars["String"]
    kitchenName?: Maybe<Scalars["String"]>
}

export type CategoryOptionGroup = {
    id: Scalars["String"]
    name: Scalars["String"]
    displayName?: Maybe<Scalars["String"]>
    price: Array<Scalars["Int"]>
    displayType: Scalars["String"]
    isActive: Scalars["Boolean"]
    options: Array<CategoryOption>
    addedToItems: Array<AddedToItem>
}

export type CategoryOptionGroupOverride = {
    locationId: Scalars["String"]
    data: CategoryOptionGroupOverrideData
}

export type CategoryOptionGroupOverrideData = {
    id: Scalars["String"]
    price?: Maybe<Array<Scalars["Int"]>>
    isActive?: Maybe<Scalars["Boolean"]>
}

export type CategoryOptionGroupResponse = {
    data: Array<CategoryOptionGroup>
    overrides: Array<CategoryOptionGroupOverride>
}

export type CategoryPricing = {
    id: Scalars["String"]
    name: Scalars["String"]
    isActive?: Maybe<Scalars["Boolean"]>
    isAutoApply?: Maybe<Scalars["Boolean"]>
    autoApplyHours?: Maybe<Array<TimeSpan>>
    parentOverride?: Maybe<CategoryPricingParentOverride>
}

export type CategoryPricingOverride = {
    id: Scalars["String"]
    isActive?: Maybe<Scalars["Boolean"]>
    isAutoApply?: Maybe<Scalars["Boolean"]>
    autoApplyHours?: Maybe<Array<TimeSpan>>
}

export type CategoryPricingParentOverride = {
    isActive?: Maybe<Scalars["Boolean"]>
    isAutoApply?: Maybe<Scalars["Boolean"]>
}

export enum CategoryPricingType {
    Fixed = "fixed",
    UnitBased = "unitBased",
    SetInOptions = "setInOptions",
    SetUponSale = "setUponSale",
}

export type CategoryTax = {
    id: Scalars["String"]
    name: Scalars["String"]
    isActive?: Maybe<Scalars["Boolean"]>
    isAutoApply?: Maybe<Scalars["Boolean"]>
    isEmbedded?: Maybe<Scalars["Boolean"]>
    parentOverride?: Maybe<CategoryTaxParentOverride>
}

export type CategoryTaxOverride = {
    id: Scalars["String"]
    isActive?: Maybe<Scalars["Boolean"]>
    isAutoApply?: Maybe<Scalars["Boolean"]>
    isEmbedded?: Maybe<Scalars["Boolean"]>
}

export type CategoryTaxParentOverride = {
    isActive?: Maybe<Scalars["Boolean"]>
    isAutoApply?: Maybe<Scalars["Boolean"]>
    isEmbedded?: Maybe<Scalars["Boolean"]>
}

export enum CategoryType {
    Category = "category",
    Product = "product",
    Option = "option",
    Modifier = "modifier",
}

export type CfdIdleScreenTheme = {
    title?: Maybe<Scalars["String"]>
    description?: Maybe<Scalars["String"]>
    logoUrl?: Maybe<Scalars["String"]>
    bgImagesUrls?: Maybe<Array<Scalars["String"]>>
    bgImagesIntervalMs?: Maybe<Scalars["Int"]>
}

export type CfdIdleScreenThemeInput = {
    title?: Maybe<Scalars["String"]>
    description?: Maybe<Scalars["String"]>
    logoUrl?: Maybe<Scalars["String"]>
    bgImagesUrls?: Maybe<Array<Scalars["String"]>>
    bgImagesIntervalMs?: Maybe<Scalars["Int"]>
}

export type CfdMetadata = {
    isCFDConnectionEnabled: Scalars["Boolean"]
    theme?: Maybe<CfdTheme>
}

export type CfdMetadataInput = {
    isCFDConnectionEnabled: Scalars["Boolean"]
    theme?: Maybe<CfdThemeInput>
}

export type CfdOrderScreenTheme = {
    promoImagesUrls?: Maybe<Array<Scalars["String"]>>
    promoImagesIntervalMs?: Maybe<Scalars["Int"]>
}

export type CfdOrderScreenThemeInput = {
    promoImagesUrls?: Maybe<Array<Scalars["String"]>>
    promoImagesIntervalMs?: Maybe<Scalars["Int"]>
}

export type CfdTheme = {
    idleScreen?: Maybe<CfdIdleScreenTheme>
    orderScreen?: Maybe<CfdOrderScreenTheme>
}

export type CfdThemeInput = {
    idleScreen?: Maybe<CfdIdleScreenThemeInput>
    orderScreen?: Maybe<CfdOrderScreenThemeInput>
}

export type CheckCardData = {
    id: Scalars["String"]
    state: Scalars["String"]
    type: Scalars["String"]
    balance?: Maybe<Scalars["Int"]>
    merchant: CheckCardDataMerchant
}

export type CheckCardDataMerchant = {
    name: Scalars["String"]
    logo?: Maybe<Scalars["String"]>
}

export type Coupon = {
    isRedeemable: Scalars["Boolean"]
    enableIssuing: Scalars["Boolean"]
    redeemingMinOrderTotal?: Maybe<Scalars["Int"]>
    percentage?: Maybe<Scalars["Int"]>
    absolute?: Maybe<Scalars["Int"]>
    from?: Maybe<Scalars["String"]>
    until?: Maybe<Scalars["String"]>
    code?: Maybe<Scalars["String"]>
    link?: Maybe<Scalars["String"]>
    isSingleUsePerCustomer: Scalars["Boolean"]
}

export type CouponSaveRequestData = {
    enableIssuing: Scalars["Boolean"]
    redeemingMinOrderTotal?: Maybe<Scalars["Int"]>
    percentage?: Maybe<Scalars["Int"]>
    absolute?: Maybe<Scalars["Int"]>
    from?: Maybe<Scalars["String"]>
    until?: Maybe<Scalars["String"]>
    code?: Maybe<Scalars["String"]>
    link?: Maybe<Scalars["String"]>
    isSingleUsePerCustomer?: Maybe<Scalars["Boolean"]>
}

export type CropCoords = {
    x: Scalars["Int"]
    y: Scalars["Int"]
    width: Scalars["Int"]
    height: Scalars["Int"]
}

export type CustomerReportItem = {
    id: Scalars["String"]
    customerName?: Maybe<Scalars["String"]>
    companyName?: Maybe<Scalars["String"]>
    customerPersonalName?: Maybe<Scalars["String"]>
    email?: Maybe<Scalars["String"]>
    gender?: Maybe<Scalars["String"]>
    isCompany: Scalars["Boolean"]
    phoneNumber?: Maybe<Scalars["String"]>
    position?: Maybe<Scalars["String"]>
    last28daysSpend?: Maybe<Scalars["Int"]>
    lastVisitDatetime?: Maybe<Scalars["String"]>
    lastVisitSpend?: Maybe<Scalars["Int"]>
    lastTransactionSpend?: Maybe<Scalars["Int"]>
    numberOfVisits?: Maybe<Scalars["Int"]>
    totalSpend?: Maybe<Scalars["Int"]>
    averageSpend?: Maybe<Scalars["Int"]>
    valuation?: Maybe<Scalars["Float"]>
    mostFrequent?: Maybe<Scalars["String"]>
}

export type CustomerReportResponse = {
    data: Array<CustomerReportItem>
    totalCount: Scalars["Int"]
}

export type DeliveryAreaConfig = {
    type?: Maybe<DeliveryAreaType>
    deliveryDistance?: Maybe<Scalars["Float"]>
    deliveryZipCodes?: Maybe<Array<Scalars["String"]>>
    deliveryMapAreas?: Maybe<Array<DeliveryMapAreaData>>
}

export type DeliveryAreaConfigSaveRequest = {
    type: DeliveryAreaType
    deliveryDistance?: Maybe<Scalars["Float"]>
    deliveryZipCodes?: Maybe<Array<Scalars["String"]>>
    deliveryMapAreas?: Maybe<Array<DeliveryMapAreaDataSaveRequest>>
}

export enum DeliveryAreaType {
    Disabled = "disabled",
    Distance = "distance",
    ZipCodes = "zipCodes",
    Areas = "areas",
}

export type DeliveryFeeConfig = {
    deliveryFeeEnabled: Scalars["Boolean"]
    baseDeliveryFee?: Maybe<Scalars["Int"]>
    freeDelivery?: Maybe<Scalars["Int"]>
    distanceFeeEnabled: Scalars["Boolean"]
    distanceFeeValues?: Maybe<Array<DistanceFeeItem>>
}

export type DeliveryFeeConfigSaveRequest = {
    deliveryFeeEnabled?: Maybe<Scalars["Boolean"]>
    baseDeliveryFee?: Maybe<Scalars["Int"]>
    freeDelivery?: Maybe<Scalars["Int"]>
    distanceFeeEnabled?: Maybe<Scalars["Boolean"]>
    distanceFeeValues?: Maybe<Array<DistanceFeeItemSaveRequest>>
}

export type DeliveryMapAreaCoords = {
    lat: Scalars["Float"]
    lng: Scalars["Float"]
}

export type DeliveryMapAreaCoordsSaveRequest = {
    lat: Scalars["Float"]
    lng: Scalars["Float"]
}

export type DeliveryMapAreaData = {
    id: Scalars["String"]
    fee?: Maybe<Scalars["Int"]>
    minOrderAmount?: Maybe<Scalars["Int"]>
    coords: Array<DeliveryMapAreaCoords>
}

export type DeliveryMapAreaDataSaveRequest = {
    id: Scalars["String"]
    fee?: Maybe<Scalars["Int"]>
    minOrderAmount?: Maybe<Scalars["Int"]>
    coords: Array<DeliveryMapAreaCoordsSaveRequest>
}

export type DeliveryPartnersData = {
    pickupDelay?: Maybe<Scalars["Int"]>
    pickupInstructions?: Maybe<Scalars["String"]>
    phoneContactForDelivery?: Maybe<Scalars["String"]>
    doordashEnabled: Scalars["Boolean"]
    doordashAllowedVehicles?: Maybe<Array<Scalars["String"]>>
    relayEnabled: Scalars["Boolean"]
    relayProducerKey?: Maybe<Scalars["String"]>
    relayApiKey?: Maybe<Scalars["String"]>
    ondyEnabled: Scalars["Boolean"]
    uberEnabled?: Maybe<Scalars["Boolean"]>
    uberDirectOrganizationId?: Maybe<Scalars["String"]>
    onfleetEnabled: Scalars["Boolean"]
    onfleetApiKey?: Maybe<Scalars["String"]>
    onfleetWebhookSecret?: Maybe<Scalars["String"]>
    shipdayEnabled: Scalars["Boolean"]
    shipdayApiKey?: Maybe<Scalars["String"]>
    shipdayWebhookSecret?: Maybe<Scalars["String"]>
    ateamEnabled: Scalars["Boolean"]
    selfDeliveryEnabled: Scalars["Boolean"]
}

export type DeliveryPartnersDataSaveRequest = {
    pickupDelay?: Maybe<Scalars["Int"]>
    pickupInstructions?: Maybe<Scalars["String"]>
    phoneContactForDelivery?: Maybe<Scalars["String"]>
    doordashEnabled: Scalars["Boolean"]
    doordashAllowedVehicles?: Maybe<Array<Scalars["String"]>>
    relayEnabled: Scalars["Boolean"]
    relayProducerKey?: Maybe<Scalars["String"]>
    relayApiKey?: Maybe<Scalars["String"]>
    ondyEnabled: Scalars["Boolean"]
    uberEnabled?: Maybe<Scalars["Boolean"]>
    uberOrganizationId?: Maybe<Scalars["String"]>
    onfleetEnabled: Scalars["Boolean"]
    onfleetApiKey?: Maybe<Scalars["String"]>
    onfleetWebhookSecret?: Maybe<Scalars["String"]>
    shipdayEnabled: Scalars["Boolean"]
    shipdayApiKey?: Maybe<Scalars["String"]>
    shipdayWebhookSecret?: Maybe<Scalars["String"]>
    ateamEnabled: Scalars["Boolean"]
    selfDeliveryEnabled: Scalars["Boolean"]
}

export type DeliverySettingsResponse = {
    deliveryFeeConfig: DeliveryFeeConfig
    deliveryAreaConfig: DeliveryAreaConfig
    deliveryPartners: DeliveryPartnersData
}

export type DeliverySettingsSaveRequest = {
    deliveryFeeConfig: DeliveryFeeConfigSaveRequest
    deliveryAreaConfig: DeliveryAreaConfigSaveRequest
    deliveryPartners: DeliveryPartnersDataSaveRequest
}

export type DistanceFeeItem = {
    distance: Scalars["Float"]
    fee: Scalars["Int"]
}

export type DistanceFeeItemSaveRequest = {
    distance: Scalars["Float"]
    fee: Scalars["Int"]
}

export type DnsRecord = {
    type: Scalars["String"]
    name: Scalars["String"]
    value: Scalars["String"]
}

export type Domain = {
    id: Scalars["String"]
    name: Scalars["String"]
    state: Scalars["String"]
    records?: Maybe<Array<DnsRecord>>
    metadata?: Maybe<Scalars["String"]>
}

export type EventDataResponse = {
    id: Scalars["String"]
    timestamp: Scalars["String"]
    expiration: Scalars["Int"]
    success: Scalars["Boolean"]
    data?: Maybe<Scalars["JSON"]>
}

export type EventSendRequestData = {
    type: Scalars["String"]
    payload?: Maybe<Scalars["String"]>
    accountId?: Maybe<Scalars["String"]>
    locationId?: Maybe<Scalars["String"]>
    terminalId?: Maybe<Scalars["String"]>
    aggregateType?: Maybe<Scalars["String"]>
    aggregateId?: Maybe<Scalars["String"]>
    correlationId?: Maybe<Scalars["String"]>
    version?: Maybe<Scalars["Int"]>
}

export type FeatureFlagSendRequestData = {
    key: Scalars["String"]
    value: Scalars["String"]
    auditData?: Maybe<AuditData>
}

export type FoodmeowStore = {
    storeId: Scalars["String"]
    name: Scalars["String"]
}

export type FoodmeowStoreConfig = {
    storeId?: Maybe<Scalars["String"]>
    storeName?: Maybe<Scalars["String"]>
    description?: Maybe<Scalars["String"]>
    logo?: Maybe<Scalars["String"]>
    images?: Maybe<Array<Scalars["String"]>>
}

export type FoodmeowStoreResponse = {
    token: Scalars["String"]
    stores: Array<FoodmeowStore>
}

export type GoogleBusinessProfile = {
    googleLocationName?: Maybe<Scalars["String"]>
    connectedAt?: Maybe<Scalars["String"]>
    reviewsSyncStatus?: Maybe<Scalars["String"]>
    reviewsSyncStartedAt?: Maybe<Scalars["String"]>
    reviewsSyncFinishedAt?: Maybe<Scalars["String"]>
    notificationSetupFailed?: Maybe<Scalars["Boolean"]>
}

export type HooSettingDataResponse = {
    isActive: Scalars["Boolean"]
    timeSpans: Array<Scalars["String"]>
}

export type HooSettingDataSaveRequest = {
    isActive: Scalars["Boolean"]
    timeSpans?: Maybe<Array<Scalars["String"]>>
}

export type HooSettingsResponse = {
    deliveryHoo: HooSettingDataResponse
    pickupHoo: HooSettingDataResponse
}

export type HooSettingsSaveRequest = {
    deliveryHoo?: Maybe<HooSettingDataSaveRequest>
    pickupHoo?: Maybe<HooSettingDataSaveRequest>
    auditData?: Maybe<AuditData>
}

export type HourlyPreparationTime = {
    index: Scalars["Int"]
    hour: Scalars["Int"]
    itemNames: Array<Scalars["String"]>
    count: Scalars["Int"]
    preparationTime?: Maybe<PreparationTime>
}

export type InItemModifier = {
    id: Scalars["String"]
    productId: Scalars["String"]
    name: Scalars["String"]
    isPreset: Scalars["Boolean"]
    isMulti: Scalars["Boolean"]
    isActive?: Maybe<Scalars["Boolean"]>
    price?: Maybe<Scalars["Int"]>
    supplement?: Maybe<Scalars["Int"]>
    nestedCategoryGroupId?: Maybe<Scalars["String"]>
}

export type InItemModifierGroup = {
    id: Scalars["String"]
    name: Scalars["String"]
    isProminent: Scalars["Boolean"]
    isExclusion: Scalars["Boolean"]
    modifiers: Array<InItemModifier>
}

export type InItemModifierOverride = {
    id: Scalars["String"]
    isPreset?: Maybe<Scalars["Boolean"]>
    isMulti?: Maybe<Scalars["Boolean"]>
    price?: Maybe<Scalars["Int"]>
    supplement?: Maybe<Scalars["Int"]>
    isActive?: Maybe<Scalars["Boolean"]>
    nestedCategoryGroupId?: Maybe<Scalars["String"]>
}

export type InItemOption = {
    id: Scalars["String"]
    productId: Scalars["String"]
    name: Scalars["String"]
    isPreset: Scalars["Boolean"]
    isActive?: Maybe<Scalars["Boolean"]>
    nestedCategoryGroupId?: Maybe<Scalars["String"]>
    price: Scalars["Int"]
}

export type InItemOptionGroup = {
    id: Scalars["String"]
    name: Scalars["String"]
    isProminent: Scalars["Boolean"]
    options: Array<InItemOption>
}

export type InItemOptionOverride = {
    id: Scalars["String"]
    price?: Maybe<Scalars["Int"]>
    isPreset?: Maybe<Scalars["Boolean"]>
    nestedCategoryGroupId?: Maybe<Scalars["String"]>
    isActive?: Maybe<Scalars["Boolean"]>
}

export type ItemPreparationTime = {
    productId?: Maybe<Scalars["String"]>
    name: Scalars["String"]
    count: Scalars["Int"]
    preparationTime: PreparationTime
}

export type KdsMetadata = {
    isExpediter?: Maybe<Scalars["Boolean"]>
}

export type KdsMetadataInput = {
    isExpediter?: Maybe<Scalars["Boolean"]>
}

export type KioskImage = {
    id: Scalars["String"]
    url: Scalars["String"]
    type: Scalars["String"]
    label?: Maybe<Scalars["String"]>
}

export type KioskImagesMetadata = {
    welcomeScreen?: Maybe<Array<KioskImage>>
    logo?: Maybe<KioskImage>
}

export type KioskMetadata = {
    images?: Maybe<KioskImagesMetadata>
}

export type Location = {
    id: Scalars["String"]
    name: Scalars["String"]
    timezone: Scalars["String"]
    terminals: Array<Terminal>
    addressLine1?: Maybe<Scalars["String"]>
    addressLine2?: Maybe<Scalars["String"]>
    addressZip?: Maybe<Scalars["String"]>
    addressCity?: Maybe<Scalars["String"]>
    addressState?: Maybe<Scalars["String"]>
    emailAddress?: Maybe<Scalars["String"]>
    phoneNumber?: Maybe<Scalars["String"]>
    websiteUrl?: Maybe<Scalars["String"]>
    latitude?: Maybe<Scalars["Float"]>
    longitude?: Maybe<Scalars["Float"]>
    googlePlaceId?: Maybe<Scalars["String"]>
    socialFacebook?: Maybe<Scalars["String"]>
    socialInstagram?: Maybe<Scalars["String"]>
    socialTwitter?: Maybe<Scalars["String"]>
    socialTikTok?: Maybe<Scalars["String"]>
    googleBusinessProfile?: Maybe<GoogleBusinessProfile>
}

export type LocationDetail = {
    id: Scalars["String"]
    name: Scalars["String"]
    timezone: Scalars["String"]
    addressLine1?: Maybe<Scalars["String"]>
    addressLine2?: Maybe<Scalars["String"]>
    addressZip?: Maybe<Scalars["String"]>
    addressCity?: Maybe<Scalars["String"]>
    addressState?: Maybe<Scalars["String"]>
    emailAddress?: Maybe<Scalars["String"]>
    phoneNumber?: Maybe<Scalars["String"]>
    websiteUrl?: Maybe<Scalars["String"]>
    latitude?: Maybe<Scalars["Float"]>
    longitude?: Maybe<Scalars["Float"]>
    googlePlaceId?: Maybe<Scalars["String"]>
    socialFacebook?: Maybe<Scalars["String"]>
    socialInstagram?: Maybe<Scalars["String"]>
    socialTwitter?: Maybe<Scalars["String"]>
    socialTikTok?: Maybe<Scalars["String"]>
    hooTimeSpans?: Maybe<Array<Scalars["String"]>>
    googleBusinessProfile?: Maybe<GoogleBusinessProfile>
}

export type LocationSaveRequestData = {
    id: Scalars["String"]
    name: Scalars["String"]
    timezone: Scalars["String"]
    addressLine1?: Maybe<Scalars["String"]>
    addressLine2?: Maybe<Scalars["String"]>
    addressZip?: Maybe<Scalars["String"]>
    addressCity?: Maybe<Scalars["String"]>
    addressState?: Maybe<Scalars["String"]>
    emailAddress?: Maybe<Scalars["String"]>
    websiteUrl?: Maybe<Scalars["String"]>
    phoneNumber?: Maybe<Scalars["String"]>
    latitude?: Maybe<Scalars["Float"]>
    longitude?: Maybe<Scalars["Float"]>
    googlePlaceId?: Maybe<Scalars["String"]>
    socialFacebook?: Maybe<Scalars["String"]>
    socialInstagram?: Maybe<Scalars["String"]>
    socialTwitter?: Maybe<Scalars["String"]>
    socialTikTok?: Maybe<Scalars["String"]>
    hooTimeSpans?: Maybe<Array<Scalars["String"]>>
    assignWithUserAccounts?: Maybe<Array<Scalars["String"]>>
    auditData?: Maybe<AuditData>
}

export type LocationsListItem = {
    id: Scalars["String"]
    name: Scalars["String"]
    timezone: Scalars["String"]
    children: Array<ServiceListItem>
}

export type LocationsListResponse = {
    locations: Array<LocationsListItem>
    masterListAccess: Scalars["Boolean"]
}

export type LocationTerminalPair = {
    locationId?: Maybe<Scalars["String"]>
    terminalId?: Maybe<Scalars["String"]>
}

export type LoyaltyInfo = {
    accrued?: Maybe<Scalars["Int"]>
}

export type ModifierGroupItem = {
    id: Scalars["String"]
    categoryId: Scalars["String"]
    name: Scalars["String"]
    price?: Maybe<Scalars["Int"]>
    supplement?: Maybe<Scalars["Int"]>
}

export type ModifierGroupItemOverride = {
    id: Scalars["String"]
    price?: Maybe<Scalars["Int"]>
    supplement?: Maybe<Scalars["Int"]>
}

export type ModifierGroupLocationSaveRequestData = {
    id: Scalars["String"]
    locationId: Scalars["String"]
    isActive: Scalars["Boolean"]
    min?: Maybe<Scalars["Int"]>
    max?: Maybe<Scalars["Int"]>
    free?: Maybe<Scalars["Int"]>
    groupPrice?: Maybe<Scalars["Int"]>
    modifiers: Array<ModifierGroupModifierLocationSaveRequestData>
    auditData?: Maybe<AuditData>
}

export type ModifierGroupModifierLocationSaveRequestData = {
    id: Scalars["String"]
    price?: Maybe<Scalars["Int"]>
    categoryId: Scalars["String"]
    supplement?: Maybe<Scalars["Int"]>
}

export type ModifierGroupModifierSaveRequestData = {
    id: Scalars["String"]
    categoryId: Scalars["String"]
    price: Scalars["Int"]
    supplement: Scalars["Int"]
}

export type ModifierGroupSaveRequestData = {
    id: Scalars["String"]
    name: Scalars["String"]
    displayName?: Maybe<Scalars["String"]>
    isActive: Scalars["Boolean"]
    isActivePOS: Scalars["Boolean"]
    isActiveMIB: Scalars["Boolean"]
    isActiveKiosk: Scalars["Boolean"]
    displayType: Scalars["String"]
    isExclusion: Scalars["Boolean"]
    min?: Maybe<Scalars["Int"]>
    max?: Maybe<Scalars["Int"]>
    free?: Maybe<Scalars["Int"]>
    groupPrice?: Maybe<Scalars["Int"]>
    modifiers: Array<ModifierGroupModifierSaveRequestData>
    isCreating?: Maybe<Scalars["Boolean"]>
    auditData?: Maybe<AuditData>
}

export type ModifierInGroup = {
    id: Scalars["String"]
    groupId: Scalars["String"]
    name: Scalars["String"]
    price?: Maybe<Scalars["Int"]>
    supplement?: Maybe<Scalars["Int"]>
}

export type ModifierLocationSaveRequestData = {
    id: Scalars["String"]
    locationId: Scalars["String"]
    isActive: Scalars["Boolean"]
    auditData?: Maybe<AuditData>
}

export type ModifierSaveRequestData = {
    id: Scalars["String"]
    name: Scalars["String"]
    kitchenName?: Maybe<Scalars["String"]>
    isCreating?: Maybe<Scalars["Boolean"]>
    isActive: Scalars["Boolean"]
    auditData?: Maybe<AuditData>
}

export type Mutation = {
    receiptSend?: Maybe<ResponseData>
    locationSave?: Maybe<ResponseData>
    locationDelete?: Maybe<ResponseData>
    terminalAdd?: Maybe<TerminalAddResponseData>
    terminalUpdate?: Maybe<ResponseData>
    terminalDelete?: Maybe<ResponseData>
    assignmentAdd?: Maybe<ResponseData>
    assignmentUpdate?: Maybe<ResponseData>
    assignmentDelete?: Maybe<ResponseData>
    schematizedSave?: Maybe<ResponseData>
    schematizedLayoutDelete?: Maybe<ResponseData>
    optionGroupSave?: Maybe<ResponseData>
    optionGroupLocationSave?: Maybe<ResponseData>
    optionGroupDelete?: Maybe<ResponseData>
    modifierSave?: Maybe<ResponseData>
    modifierLocationSave?: Maybe<ResponseData>
    modifierDelete?: Maybe<ResponseData>
    modifierGroupSave?: Maybe<ResponseData>
    modifierGroupLocationSave?: Maybe<ResponseData>
    modifierGroupDelete?: Maybe<ResponseData>
    pricingSave?: Maybe<PricingSaveResponseData>
    pricingLocationSave?: Maybe<PricingLocationSaveResponseData>
    pricingDelete?: Maybe<ResponseData>
    pricingSort?: Maybe<ResponseData>
    promotionSave?: Maybe<ResponseData>
    promotionDelete?: Maybe<ResponseData>
    settingsSave?: Maybe<ResponseData>
    paymentsSettingsSave?: Maybe<ResponseData>
    onlineOrderingSettingsSave?: Maybe<ResponseData>
    customerDelete?: Maybe<ResponseData>
    cardProgramSave?: Maybe<ResponseData>
    cardProgramCardResendEmail?: Maybe<ResponseData>
    operationsSend?: Maybe<ResponseData>
    eventSend?: Maybe<ResponseData>
    featureFlagSend?: Maybe<ResponseData>
    linkUberStore?: Maybe<ResponseData>
    linkFoodmeowStore?: Maybe<ResponseData>
    generateAggregatorEmail?: Maybe<ResponseData>
    removeIntegration?: Maybe<ResponseData>
    domainSave?: Maybe<ResponseData>
    accountConsoleSave?: Maybe<ResponseData>
    menuSyncInit?: Maybe<ResponseData>
    ondyPlatform: Scalars["String"]
}

export type MutationReceiptSendArgs = {
    data: ReceiptSendRequestData
}

export type MutationLocationSaveArgs = {
    data: LocationSaveRequestData
}

export type MutationLocationDeleteArgs = {
    locationId: Scalars["String"]
}

export type MutationTerminalAddArgs = {
    data: TerminalAddRequestData
}

export type MutationTerminalUpdateArgs = {
    data: TerminalUpdateRequestData
}

export type MutationTerminalDeleteArgs = {
    terminalId: Scalars["String"]
}

export type MutationAssignmentAddArgs = {
    data: AssignmentAddUpdateRequestData
}

export type MutationAssignmentUpdateArgs = {
    data: AssignmentAddUpdateRequestData
    assignmentId: Scalars["String"]
}

export type MutationAssignmentDeleteArgs = {
    assignmentId: Scalars["String"]
    locationId?: Maybe<Scalars["String"]>
}

export type MutationSchematizedSaveArgs = {
    data: SchematizedSaveData
}

export type MutationSchematizedLayoutDeleteArgs = {
    data: SchematizedLayoutDeleteData
}

export type MutationOptionGroupSaveArgs = {
    data: OptionGroupSaveRequestData
}

export type MutationOptionGroupLocationSaveArgs = {
    data: OptionGroupLocationSaveRequestData
}

export type MutationOptionGroupDeleteArgs = {
    id: Scalars["String"]
    auditData?: Maybe<AuditData>
}

export type MutationModifierSaveArgs = {
    data: ModifierSaveRequestData
}

export type MutationModifierLocationSaveArgs = {
    data: ModifierLocationSaveRequestData
}

export type MutationModifierDeleteArgs = {
    id: Scalars["String"]
    auditData?: Maybe<AuditData>
}

export type MutationModifierGroupSaveArgs = {
    data: ModifierGroupSaveRequestData
}

export type MutationModifierGroupLocationSaveArgs = {
    data: ModifierGroupLocationSaveRequestData
}

export type MutationModifierGroupDeleteArgs = {
    id: Scalars["String"]
    auditData?: Maybe<AuditData>
}

export type MutationPricingSaveArgs = {
    data: PricingSaveRequestData
}

export type MutationPricingLocationSaveArgs = {
    data: PricingLocationSaveRequestData
}

export type MutationPricingDeleteArgs = {
    id: Scalars["String"]
    auditData?: Maybe<AuditData>
    pricingType?: Maybe<PricingType>
}

export type MutationPricingSortArgs = {
    data: PricingSortRequestData
}

export type MutationPromotionSaveArgs = {
    data: PromotionSaveRequestData
}

export type MutationPromotionDeleteArgs = {
    id: Scalars["String"]
}

export type MutationSettingsSaveArgs = {
    data: SettingsSaveRequest
}

export type MutationPaymentsSettingsSaveArgs = {
    data: PaymentsSettingsSaveRequest
}

export type MutationOnlineOrderingSettingsSaveArgs = {
    data: OnlineOrderingSettingsSaveRequest
}

export type MutationCustomerDeleteArgs = {
    id: Scalars["String"]
}

export type MutationCardProgramSaveArgs = {
    data: CardProgramSaveRequestData
}

export type MutationCardProgramCardResendEmailArgs = {
    data: CardProgramCardResendEmailData
}

export type MutationOperationsSendArgs = {
    data: OperationsSendRequestData
}

export type MutationEventSendArgs = {
    data: EventSendRequestData
}

export type MutationFeatureFlagSendArgs = {
    data: FeatureFlagSendRequestData
}

export type MutationLinkUberStoreArgs = {
    auth: OAuthTokensInput
    storeId: Scalars["String"]
    terminalId: Scalars["String"]
    locationId: Scalars["String"]
}

export type MutationLinkFoodmeowStoreArgs = {
    token: Scalars["String"]
    storeId: Scalars["String"]
    terminalId: Scalars["String"]
    locationId: Scalars["String"]
}

export type MutationGenerateAggregatorEmailArgs = {
    terminalId: Scalars["String"]
    locationId: Scalars["String"]
    aggregatorType?: Maybe<Scalars["String"]>
}

export type MutationRemoveIntegrationArgs = {
    data: RemoveIntegrationRequestData
}

export type MutationDomainSaveArgs = {
    name: Scalars["String"]
}

export type MutationAccountConsoleSaveArgs = {
    input: AccountConsoleSettingsSave
}

export type MutationMenuSyncInitArgs = {
    terminalId: Scalars["String"]
}

export type MutationOndyPlatformArgs = {
    platform: Scalars["String"]
}

export type OAuthTokens = {
    accessToken: Scalars["String"]
    refreshToken: Scalars["String"]
    expiresIn: Scalars["Int"]
}

export type OAuthTokensInput = {
    accessToken: Scalars["String"]
    refreshToken: Scalars["String"]
    expiresIn: Scalars["Int"]
}

export type OnlineOrderingImages = {
    locationImageUrl?: Maybe<Scalars["String"]>
}

export type OnlineOrderingImagesInput = {
    locationImageUrl?: Maybe<Scalars["String"]>
}

export type OnlineOrderingMetadata = {
    status?: Maybe<Scalars["String"]>
    menuUpdateStatus?: Maybe<Scalars["String"]>
    priceMultiplier?: Maybe<Scalars["Float"]>
    shouldRoundUpPrices?: Maybe<Scalars["Boolean"]>
    webOrderingEnabled?: Maybe<Scalars["Boolean"]>
    mobileOrderingEnabled?: Maybe<Scalars["Boolean"]>
    googleOrderingLinkEnabled?: Maybe<Scalars["Boolean"]>
    images?: Maybe<OnlineOrderingImages>
}

export type OnlineOrderingMetadataInput = {
    priceMultiplier?: Maybe<Scalars["Float"]>
    shouldRoundUpPrices?: Maybe<Scalars["Boolean"]>
    webOrderingEnabled?: Maybe<Scalars["Boolean"]>
    mobileOrderingEnabled?: Maybe<Scalars["Boolean"]>
    googleOrderingLinkEnabled?: Maybe<Scalars["Boolean"]>
    images?: Maybe<OnlineOrderingImagesInput>
}

export type OnlineOrderingSettingsResponse = {
    logoUrl?: Maybe<Scalars["String"]>
    iconUrl?: Maybe<Scalars["String"]>
    desktopImageUrl?: Maybe<Scalars["String"]>
}

export type OnlineOrderingSettingsSaveRequest = {
    locationId: Scalars["String"]
    terminalId: Scalars["String"]
    logoUrl?: Maybe<Scalars["String"]>
    bgImageUrl?: Maybe<Scalars["String"]>
    iconUrl?: Maybe<Scalars["String"]>
    auditData?: Maybe<AuditData>
}

export enum OnlineOrderingSource {
    Mobile = "mobile",
    Web = "web",
}

export type OnlineReceiptHtmlResponse = {
    html: Scalars["String"]
    data?: Maybe<OnlineReceiptOrderData>
}

export type OnlineReceiptOrderData = {
    accountId?: Maybe<Scalars["String"]>
    orderId?: Maybe<Scalars["String"]>
    merchantName?: Maybe<Scalars["String"]>
    merchantLogo?: Maybe<Scalars["String"]>
}

export type Operation = {
    id: Scalars["String"]
    type?: Maybe<Scalars["String"]>
    recordType?: Maybe<Scalars["String"]>
    recordId?: Maybe<Scalars["String"]>
    params?: Maybe<Scalars["String"]>
}

export type OperationsSendRequestData = {
    terminalIds?: Maybe<Array<Scalars["String"]>>
    operations: Array<Operation>
}

export type OptionGroupLocationSaveRequestData = {
    id: Scalars["String"]
    locationId: Scalars["String"]
    isActive: Scalars["Boolean"]
    auditData?: Maybe<AuditData>
}

export type OptionGroupOptionSaveRequestData = {
    id: Scalars["String"]
    productId: Scalars["String"]
    name: Scalars["String"]
    kitchenName?: Maybe<Scalars["String"]>
}

export type OptionGroupSaveRequestData = {
    name: Scalars["String"]
    id: Scalars["String"]
    displayName?: Maybe<Scalars["String"]>
    displayType?: Maybe<Scalars["String"]>
    isActive: Scalars["Boolean"]
    options: Array<OptionGroupOptionSaveRequestData>
    isCreating?: Maybe<Scalars["Boolean"]>
    auditData?: Maybe<AuditData>
}

export type OrderAudit = {
    type?: Maybe<Scalars["String"]>
    serviceName?: Maybe<Scalars["String"]>
    userName?: Maybe<Scalars["String"]>
    timestamp?: Maybe<Scalars["String"]>
    note?: Maybe<Scalars["String"]>
}

export type OrderDelivery = {
    id: Scalars["String"]
    externalService?: Maybe<Scalars["String"]>
    deliveryState?: Maybe<OrderDeliveryState>
    deliveryFee?: Maybe<Scalars["Int"]>
    actualPickupTime?: Maybe<Scalars["String"]>
    actualDropoffTime?: Maybe<Scalars["String"]>
    trackingUrl?: Maybe<Scalars["String"]>
    pickupLocation?: Maybe<OrderDeliveryLocation>
    deliveryLocation?: Maybe<OrderDeliveryLocation>
}

export type OrderDeliveryLocation = {
    street?: Maybe<Scalars["String"]>
    unit?: Maybe<Scalars["String"]>
    city?: Maybe<Scalars["String"]>
    state?: Maybe<Scalars["String"]>
    zip?: Maybe<Scalars["String"]>
}

export enum OrderDeliveryState {
    Pending = "pending",
    Requested = "requested",
    Confirmed = "confirmed",
    Declined = "declined",
    PickedUp = "picked_up",
    Completed = "completed",
    Failed = "failed",
    Unknown = "unknown",
}

export type OrderDetail = {
    items?: Maybe<Array<OrderDetailItem>>
    totals?: Maybe<OrderTotals>
    loyalty?: Maybe<LoyaltyInfo>
    general?: Maybe<OrderGeneralInfo>
    fulfillment?: Maybe<OrderFulfillment>
    transactions?: Maybe<Array<OrderTransaction>>
    deliveries?: Maybe<Array<OrderDelivery>>
}

export type OrderDetailItem = {
    id: Scalars["String"]
    name: Scalars["String"]
    note?: Maybe<Scalars["String"]>
    unitPrice?: Maybe<Scalars["Int"]>
    unitQuantity?: Maybe<Scalars["Int"]>
    unit?: Maybe<Scalars["String"]>
    quantity: Scalars["Int"]
    basePrice: Scalars["Int"]
    itemPrice: Scalars["Int"]
    totalPrice: Scalars["Int"]
    secondaryLine?: Maybe<Scalars["String"]>
    option?: Maybe<OrderDetailItemModifier>
    modifierGroups?: Maybe<Array<OrderDetailItemModifierGroup>>
    pricings?: Maybe<Array<OrderPricing>>
    cardProgram?: Maybe<OrderItemCardProgramData>
}

export type OrderDetailItemModifier = {
    id: Scalars["String"]
    name: Scalars["String"]
    quantity: Scalars["Int"]
    price?: Maybe<Scalars["Int"]>
    supplement?: Maybe<Scalars["Int"]>
    nestedGroups?: Maybe<Array<OrderDetailItemModifierGroup>>
}

export type OrderDetailItemModifierGroup = {
    name?: Maybe<Scalars["String"]>
    price?: Maybe<Scalars["Int"]>
    isExclusion?: Maybe<Scalars["Boolean"]>
    modifiers?: Maybe<Array<OrderDetailItemModifier>>
}

export type OrderDetailRequestData = {
    id: Scalars["String"]
}

export type OrderFulfillment = {
    recipient?: Maybe<OrderRecipient>
}

export type OrderGeneralInfo = {
    orderNumber?: Maybe<Scalars["String"]>
    orderStatus?: Maybe<Scalars["String"]>
    orderSource?: Maybe<Scalars["String"]>
    onlineOrderingSource?: Maybe<OnlineOrderingSource>
    guestCount?: Maybe<Scalars["Int"]>
    paymentStatus?: Maybe<Scalars["String"]>
    assigneeName?: Maybe<Scalars["String"]>
    assignmentName?: Maybe<Scalars["String"]>
    customerName?: Maybe<Scalars["String"]>
    customerEmail?: Maybe<Scalars["String"]>
    customerPhone?: Maybe<Scalars["String"]>
    timestampOpened?: Maybe<Scalars["String"]>
    timestampClosed?: Maybe<Scalars["String"]>
    timestampAccepted?: Maybe<Scalars["String"]>
    timestampDeclined?: Maybe<Scalars["String"]>
    timestampScheduled?: Maybe<Scalars["String"]>
    timestampExpected?: Maybe<Scalars["String"]>
    timestampReady?: Maybe<Scalars["String"]>
    timestampReadyEstimated?: Maybe<Scalars["String"]>
    timestampReadyActual?: Maybe<Scalars["String"]>
    locationId?: Maybe<Scalars["String"]>
    locationName?: Maybe<Scalars["String"]>
    note?: Maybe<Scalars["String"]>
    declineReason?: Maybe<Scalars["String"]>
    readyEstimated?: Maybe<Scalars["String"]>
    readyActual?: Maybe<Scalars["String"]>
    pickupEstimated?: Maybe<Scalars["String"]>
    pickupActual?: Maybe<Scalars["String"]>
    deliveryEstimated?: Maybe<Scalars["String"]>
    deliveryActual?: Maybe<Scalars["String"]>
    orderAudit?: Maybe<Array<OrderAudit>>
}

export type OrderItemCardProgramData = {
    cardId: Scalars["String"]
    cardProgramId: Scalars["String"]
}

export type OrderPricing = {
    type: Scalars["String"]
    name: Scalars["String"]
    absolute?: Maybe<Scalars["Int"]>
    percentage?: Maybe<Scalars["Int"]>
    subtotal?: Maybe<Scalars["Int"]>
}

export type OrderRecipient = {
    firstName?: Maybe<Scalars["String"]>
    surname?: Maybe<Scalars["String"]>
    emailAddress?: Maybe<Scalars["String"]>
}

export type OrderReportItem = {
    id: Scalars["String"]
    orderNumber: Scalars["String"]
    opened: Scalars["String"]
    closed?: Maybe<Scalars["String"]>
    deleted: Scalars["Boolean"]
    assigneeName?: Maybe<Scalars["String"]>
    assignment?: Maybe<Scalars["String"]>
    cardNames?: Maybe<Array<Maybe<Scalars["String"]>>>
    externalTypes?: Maybe<Array<Maybe<Scalars["String"]>>>
    customerName?: Maybe<Scalars["String"]>
    locationId: Scalars["String"]
    locationName: Scalars["String"]
    paymentStatus?: Maybe<Scalars["String"]>
    paymentStatusCode?: Maybe<Scalars["String"]>
    paymentTypes?: Maybe<Array<Maybe<Scalars["String"]>>>
    status?: Maybe<Scalars["String"]>
    source?: Maybe<Scalars["String"]>
    tipsAmount?: Maybe<Scalars["Int"]>
    gratuityAmount?: Maybe<Scalars["Int"]>
    terminalName?: Maybe<Scalars["String"]>
    total?: Maybe<Scalars["Int"]>
}

export type OrderReportResponse = {
    data: Array<OrderReportItem>
    totalCount: Scalars["Int"]
}

export type OrdersReportRequestData = {
    from: Scalars["String"]
    to: Scalars["String"]
    fromDate?: Maybe<Scalars["String"]>
    toDate?: Maybe<Scalars["String"]>
    count: Scalars["Int"]
    offset: Scalars["Int"]
    timezone: Scalars["String"]
    locationIds?: Maybe<Scalars["String"]>
    assigneeIds?: Maybe<Scalars["String"]>
    search?: Maybe<Scalars["String"]>
    source?: Maybe<Scalars["String"]>
    sort?: Maybe<Scalars["String"]>
    sortOrder?: Maybe<Scalars["String"]>
    isActive?: Maybe<Scalars["Boolean"]>
}

export type OrderTax = {
    name: Scalars["String"]
    absolute?: Maybe<Scalars["Int"]>
    percentage?: Maybe<Scalars["Int"]>
    total?: Maybe<Scalars["Int"]>
}

export type OrderTotals = {
    subtotal?: Maybe<Scalars["Int"]>
    pricingsTotal?: Maybe<Scalars["Int"]>
    pricings?: Maybe<Array<OrderPricing>>
    taxesTotal?: Maybe<Scalars["Int"]>
    taxes?: Maybe<Array<OrderTax>>
    total?: Maybe<Scalars["Int"]>
    tip?: Maybe<Scalars["Int"]>
    gratuityPercentage?: Maybe<Scalars["Int"]>
    gratuityTotal?: Maybe<Scalars["Int"]>
    cardSurchargePercentage?: Maybe<Scalars["Int"]>
    cardSurchargeTotal?: Maybe<Scalars["Int"]>
    cashDiscountPercentage?: Maybe<Scalars["Int"]>
    cashDiscountTotal?: Maybe<Scalars["Int"]>
    serviceFeeTotal?: Maybe<Scalars["Int"]>
    serviceFeePercentage?: Maybe<Scalars["Int"]>
    collected?: Maybe<Scalars["Int"]>
}

export type OrderTransaction = {
    id: Scalars["String"]
    type?: Maybe<Scalars["String"]>
    amount?: Maybe<Scalars["Int"]>
    transactionNumber?: Maybe<Scalars["String"]>
    status?: Maybe<Scalars["String"]>
    transactorName?: Maybe<Scalars["String"]>
    terminalName?: Maybe<Scalars["String"]>
    paymentType?: Maybe<Scalars["String"]>
    cardLast4?: Maybe<Scalars["String"]>
    externalType?: Maybe<Scalars["String"]>
    timestamp: Scalars["String"]
    signature?: Maybe<Scalars["String"]>
    paymentRequestId?: Maybe<Scalars["String"]>
    gateway?: Maybe<Scalars["String"]>
    processingDeferred?: Maybe<Scalars["Boolean"]>
}

export type OsbMetadata = {
    blacklistAssignmentIds: Array<Scalars["String"]>
    readyFallOfTimeMs: Scalars["Int"]
}

export type OsbMetadataInput = {
    blacklistAssignmentIds: Array<Scalars["String"]>
    readyFallOfTimeMs: Scalars["Int"]
}

export type Override = {
    context: Scalars["String"]
    contextId: Scalars["String"]
    data?: Maybe<Scalars["JSON"]>
}

export type OverrideInput = {
    context: Scalars["String"]
    contextId: Scalars["String"]
    data: Scalars["JSON"]
}

export type PaymentRequestDetailResponse = {
    data?: Maybe<Scalars["String"]>
}

export type PaymentsSettingsSaveRequest = {
    locationTerminalIds?: Maybe<Array<LocationTerminalPair>>
    serviceFeeSettings?: Maybe<ServiceFeeSettingsSaveRequest>
    cashPaymentSettings?: Maybe<CashPaymentSettingsSaveRequest>
    auditData?: Maybe<AuditData>
}

export type PosMetadata = {
    CFD?: Maybe<CfdMetadata>
}

export type PosMetadataInput = {
    CFD?: Maybe<CfdMetadataInput>
}

export type PreparationTime = {
    average: Scalars["Int"]
    min: Scalars["Int"]
    max: Scalars["Int"]
    p50: Scalars["Int"]
    p75: Scalars["Int"]
    p90: Scalars["Int"]
}

export type PreparationTimeByItemReport = {
    items: Array<ItemPreparationTime>
}

export type PreparationTimeByItemRequestData = {
    from: Scalars["String"]
    to: Scalars["String"]
    locationIds: Scalars["String"]
}

export type PreparationTimeHourlyReport = {
    hours: Array<HourlyPreparationTime>
}

export type PreparationTimeHourlyRequestData = {
    from: Scalars["String"]
    to: Scalars["String"]
    locationIds: Scalars["String"]
}

export type PreparedFileUploadResponse = {
    signedRequest: Scalars["JSON"]
    url: Scalars["String"]
}

export type PreparedImageUploadResponse = {
    signedRequest: Scalars["JSON"]
    url: Scalars["String"]
}

export type Pricing = {
    id: Scalars["String"]
    name: Scalars["String"]
    percentage?: Maybe<Scalars["Int"]>
    absolute?: Maybe<Scalars["Int"]>
    isOrderLevel: Scalars["Boolean"]
    isItemLevel: Scalars["Boolean"]
    isActive: Scalars["Boolean"]
    isAutoApply: Scalars["Boolean"]
    autoApplyHours?: Maybe<TimeEntry>
    sortIndex?: Maybe<Scalars["Int"]>
}

export type PricingLocationSaveRequestData = {
    id: Scalars["String"]
    locationId: Scalars["String"]
    isActive: Scalars["Boolean"]
    isAutoApply: Scalars["Boolean"]
    autoApplyHours?: Maybe<Array<TimeSpanSaveRequestData>>
    auditData?: Maybe<AuditData>
    pricingType?: Maybe<PricingType>
}

export type PricingLocationSaveResponseData = {
    data?: Maybe<PricingOverride>
}

export type PricingOverride = {
    locationId: Scalars["String"]
    data: PricingOverrideData
}

export type PricingOverrideData = {
    id: Scalars["String"]
    isActive?: Maybe<Scalars["Boolean"]>
    isAutoApply?: Maybe<Scalars["Boolean"]>
    autoApplyHours?: Maybe<TimeEntry>
}

export type PricingResponse = {
    data: Array<Pricing>
    overrides: Array<PricingOverride>
}

export type PricingSaveRequestData = {
    id: Scalars["String"]
    name: Scalars["String"]
    percentage?: Maybe<Scalars["Int"]>
    absolute?: Maybe<Scalars["Int"]>
    isOrderLevel: Scalars["Boolean"]
    isItemLevel: Scalars["Boolean"]
    isActive: Scalars["Boolean"]
    isAutoApply: Scalars["Boolean"]
    sortIndex: Scalars["Int"]
    autoApplyHours?: Maybe<Array<TimeSpanSaveRequestData>>
    isCreating: Scalars["Boolean"]
    auditData?: Maybe<AuditData>
    pricingType?: Maybe<PricingType>
}

export type PricingSaveResponseData = {
    data?: Maybe<Pricing>
}

export type PricingSortRequestData = {
    id: Scalars["String"]
    sortIndex: Scalars["Int"]
}

export enum PricingType {
    DeliveryFee = "delivery_fee",
    PromoCodeDiscount = "promo_code_discount",
    FirstTimePromoDiscount = "first_time_promo_discount",
    MoFirstOrderPromoDiscount = "mo_first_order_promo_discount",
}

export type Promotion = {
    id: Scalars["String"]
    name: Scalars["String"]
    isActive: Scalars["Boolean"]
    from?: Maybe<Scalars["String"]>
    until?: Maybe<Scalars["String"]>
    description?: Maybe<Scalars["String"]>
    coupon?: Maybe<Coupon>
    printingMinOrderTotal?: Maybe<Scalars["Int"]>
    locationIds?: Maybe<Array<Scalars["String"]>>
    sources?: Maybe<Array<Scalars["String"]>>
}

export type PromotionResponse = {
    data?: Maybe<Promotion>
}

export type PromotionSaveRequestData = {
    id: Scalars["String"]
    name: Scalars["String"]
    isActive: Scalars["Boolean"]
    from?: Maybe<Scalars["String"]>
    until?: Maybe<Scalars["String"]>
    description?: Maybe<Scalars["String"]>
    coupon?: Maybe<CouponSaveRequestData>
    printingMinOrderTotal?: Maybe<Scalars["Int"]>
    locationIds?: Maybe<Array<Scalars["String"]>>
    sources?: Maybe<Array<Scalars["String"]>>
    isCreating: Scalars["Boolean"]
}

export type Query = {
    authAccounts: Array<AuthAccount>
    authAccounts2: Array<AuthAccount2>
    authOrganizations: Array<AuthOrganization>
    authOrganizationUsers: Array<AuthOrganizationUser>
    authLocations: Array<AuthLocation>
    authLocations2: AuthLocationsResponse
    ordersReport?: Maybe<OrderReportResponse>
    customersReport?: Maybe<CustomerReportResponse>
    transactionsReport?: Maybe<TransactionReportResponse>
    cashReport?: Maybe<CashReportResponse>
    salesByItemsReport: Array<SalesByReportItem>
    specialPricingLogReport: Array<SpecialPricingLogReportItem>
    specialPricingSummaryReport: Array<SpecialPricingSummaryReportItem>
    specialPricingByEmployeeReport: Array<SpecialPricingSummaryReportItem>
    voidsSummaryReport: Array<VoidsSummaryReportItem>
    voidsLogReport: Array<VoidsLogReportItem>
    salesByModifiersReport: Array<SalesByReportItem>
    salesByModifierGroupsReport: Array<SalesByReportItem>
    preparationTimeByItemReport: PreparationTimeByItemReport
    preparationTimeHourlyReport: PreparationTimeHourlyReport
    orderDetail?: Maybe<OrderDetail>
    summaryNetCollectedBySourceReport: Array<SummaryNetCollectedBySourceReportItem>
    summaryNetCollectedBreakdownReport?: Maybe<SummaryNetCollectedBreakdownReportItem>
    summaryNetCollectedBreakdownByPaymentTypeReport: SummaryNetCollectedBreakdownByPaymentTypeReportItem
    summaryNetCollectedBreakdownByEmployeeReport: Array<SummaryNetCollectedBreakdownByEmployeeReportItem>
    summaryNetCollectedByEmployeeReport: Array<SummaryNetCollectedByEmployeeReportItem>
    summaryTransactionsByPaymentTypeReport: Array<SummaryTransactionsByPaymentTypeReportItem>
    summaryNetRevenueByCategoryReport: Array<SummaryNetRevenueByCategoryReportItem>
    summaryNetRevenueByAssignmentReport: Array<SummaryNetRevenueByAssignmentReportItem>
    summaryNetRevenueDailyReport: Array<SummaryNetRevenueDailyItem>
    summaryNetRevenueHourlyReport: Array<SummaryNetRevenueHourlyItem>
    tipsAndGratuityReport: Array<TipsAndGratuityByAssignmentReportItem>
    salesTaxReport?: Maybe<SalesTaxReportResponse>
    locationsTerminals: Array<Location>
    locationsList: Array<LocationsListItem>
    locationsList2: LocationsListResponse
    locationDetail?: Maybe<LocationDetail>
    serviceDetail?: Maybe<ServiceDetail>
    assignments: Array<Assignment>
    schematized: SchematizedData
    schematizedV2: Array<SchematizedData>
    salesInput: Array<SalesInputFolder>
    pricings?: Maybe<PricingResponse>
    promotionDetail?: Maybe<PromotionResponse>
    promotionsList: Array<Promotion>
    taxes: Array<Tax>
    timesheets?: Maybe<TimesheetsReport>
    timesheetsBreaks: Array<TimesheetsBreaksRecord>
    timesheetsLogs: Array<TimesheetsLog>
    cardPrograms?: Maybe<Array<CardProgram>>
    cardProgramCards?: Maybe<ActiveCardsResponseData>
    uberStoresByAuthCode?: Maybe<UberStoreResponse>
    uberStores?: Maybe<UberStoreResponse>
    foodmeowStoresByAuthCode?: Maybe<FoodmeowStoreResponse>
    itemsCategoriesOptionGroups?: Maybe<CategoryOptionGroupResponse>
    itemsCategoriesModifiers?: Maybe<CategoryModifierResponse>
    itemsCategoriesModifierGroups?: Maybe<CategoryModifierGroupResponse>
    categoriesList?: Maybe<CategoriesListResponse>
    categoryDetail?: Maybe<CategoryDetailResponse>
    settings: SettingsReponse
    onlineOrderingSettings: OnlineOrderingSettingsResponse
    paymentRequestDetail?: Maybe<PaymentRequestDetailResponse>
    onlineReceipt?: Maybe<OnlineReceiptHtmlResponse>
    card?: Maybe<CheckCardData>
    unmatchedOrderItemNames?: Maybe<Array<Scalars["String"]>>
    domains: Array<Domain>
    ondyPlatform: Scalars["String"]
    eventData?: Maybe<EventDataResponse>
    prepareImageUpload?: Maybe<PreparedImageUploadResponse>
    prepareFileUpload?: Maybe<PreparedFileUploadResponse>
}

export type QueryAuthAccountsArgs = {
    userId: Scalars["String"]
}

export type QueryAuthAccounts2Args = {
    userId: Scalars["String"]
}

export type QueryAuthOrganizationsArgs = {
    userId: Scalars["String"]
}

export type QueryAuthOrganizationUsersArgs = {
    organizationId: Scalars["String"]
}

export type QueryOrdersReportArgs = {
    data: OrdersReportRequestData
}

export type QueryCustomersReportArgs = {
    data: ReportRequestData
}

export type QueryTransactionsReportArgs = {
    data: ReportRequestData
}

export type QueryCashReportArgs = {
    data: CashReportRequestData
}

export type QuerySalesByItemsReportArgs = {
    data: SalesByItemsReportRequestData
}

export type QuerySpecialPricingLogReportArgs = {
    data: SpecialPricingReportRequestData
}

export type QuerySpecialPricingSummaryReportArgs = {
    data: SpecialPricingReportRequestData
}

export type QuerySpecialPricingByEmployeeReportArgs = {
    data: SpecialPricingReportRequestData
}

export type QueryVoidsSummaryReportArgs = {
    data: SpecialPricingReportRequestData
}

export type QueryVoidsLogReportArgs = {
    data: SpecialPricingReportRequestData
}

export type QuerySalesByModifiersReportArgs = {
    data: SalesByItemsReportRequestData
}

export type QuerySalesByModifierGroupsReportArgs = {
    data: SalesByItemsReportRequestData
}

export type QueryPreparationTimeByItemReportArgs = {
    data: PreparationTimeByItemRequestData
}

export type QueryPreparationTimeHourlyReportArgs = {
    data: PreparationTimeHourlyRequestData
}

export type QueryOrderDetailArgs = {
    data: OrderDetailRequestData
}

export type QuerySummaryNetCollectedBySourceReportArgs = {
    data: SummaryReportRequestData
}

export type QuerySummaryNetCollectedBreakdownReportArgs = {
    data: SummaryReportRequestData
}

export type QuerySummaryNetCollectedBreakdownByPaymentTypeReportArgs = {
    data: SummaryReportRequestData
}

export type QuerySummaryNetCollectedBreakdownByEmployeeReportArgs = {
    data: SummaryReportRequestData
}

export type QuerySummaryNetCollectedByEmployeeReportArgs = {
    data: SummaryReportRequestData
}

export type QuerySummaryTransactionsByPaymentTypeReportArgs = {
    data: SummaryReportRequestData
}

export type QuerySummaryNetRevenueByCategoryReportArgs = {
    data: SummaryReportRequestData
}

export type QuerySummaryNetRevenueByAssignmentReportArgs = {
    data: SummaryReportRequestData
}

export type QuerySummaryNetRevenueDailyReportArgs = {
    data: SummaryReportRequestData
}

export type QuerySummaryNetRevenueHourlyReportArgs = {
    data: SummaryReportRequestData
}

export type QueryTipsAndGratuityReportArgs = {
    data: SummaryReportRequestData
}

export type QuerySalesTaxReportArgs = {
    data: SummaryReportRequestData
}

export type QueryLocationDetailArgs = {
    locationId: Scalars["String"]
}

export type QueryServiceDetailArgs = {
    serviceId: Scalars["String"]
}

export type QueryAssignmentsArgs = {
    locationId?: Maybe<Scalars["String"]>
}

export type QuerySchematizedArgs = {
    locationId: Scalars["String"]
}

export type QuerySchematizedV2Args = {
    locationId: Scalars["String"]
}

export type QuerySalesInputArgs = {
    source: SalesInputSource
    locationId?: Maybe<Scalars["String"]>
    terminalId?: Maybe<Scalars["String"]>
}

export type QueryPricingsArgs = {
    locationId?: Maybe<Scalars["String"]>
}

export type QueryPromotionDetailArgs = {
    id: Scalars["String"]
}

export type QueryPromotionsListArgs = {
    locationIds?: Maybe<Array<Scalars["String"]>>
}

export type QueryTimesheetsArgs = {
    input: TimesheetsInput
}

export type QueryTimesheetsBreaksArgs = {
    input: TimesheetsBreaksInput
}

export type QueryTimesheetsLogsArgs = {
    input: TimesheetsLogsInput
}

export type QueryCardProgramCardsArgs = {
    data: ActiveCardsRequestData
}

export type QueryUberStoresByAuthCodeArgs = {
    code: Scalars["String"]
}

export type QueryUberStoresArgs = {
    serviceId: Scalars["String"]
}

export type QueryFoodmeowStoresByAuthCodeArgs = {
    code: Scalars["String"]
}

export type QueryItemsCategoriesOptionGroupsArgs = {
    locationId?: Maybe<Scalars["String"]>
}

export type QueryItemsCategoriesModifiersArgs = {
    locationId?: Maybe<Scalars["String"]>
}

export type QueryItemsCategoriesModifierGroupsArgs = {
    locationId?: Maybe<Scalars["String"]>
}

export type QueryCategoriesListArgs = {
    locationId?: Maybe<Scalars["String"]>
}

export type QueryCategoryDetailArgs = {
    categoryId: Scalars["String"]
}

export type QuerySettingsArgs = {
    locationId?: Maybe<Scalars["String"]>
    terminalId?: Maybe<Scalars["String"]>
}

export type QueryOnlineOrderingSettingsArgs = {
    locationId: Scalars["String"]
    terminalId: Scalars["String"]
}

export type QueryPaymentRequestDetailArgs = {
    id?: Maybe<Scalars["String"]>
}

export type QueryOnlineReceiptArgs = {
    id: Scalars["String"]
}

export type QueryCardArgs = {
    key: Scalars["String"]
}

export type QueryEventDataArgs = {
    correlationId: Scalars["String"]
}

export type QueryPrepareImageUploadArgs = {
    filename: Scalars["String"]
    fileType: Scalars["String"]
}

export type QueryPrepareFileUploadArgs = {
    filename: Scalars["String"]
    fileType: Scalars["String"]
    fileUploadType: Scalars["String"]
}

export type ReceiptSendRequestData = {
    orderId: Scalars["String"]
    transactionId?: Maybe<Scalars["String"]>
    orderSource?: Maybe<Scalars["String"]>
    accountId: Scalars["String"]
    emailAddress: Scalars["String"]
    template: Scalars["String"]
}

export type RemoveIntegrationRequestData = {
    storeId: Scalars["String"]
    type: AggregatorType
}

export type ReportRequestData = {
    filter?: Maybe<Scalars["String"]>
    sort?: Maybe<Scalars["String"]>
    count?: Maybe<Scalars["Int"]>
    offset?: Maybe<Scalars["Int"]>
}

export type ResponseData = {
    success?: Maybe<Scalars["Boolean"]>
}

export type SalesByItemsReportRequestData = {
    from: Scalars["String"]
    to: Scalars["String"]
    locationIds?: Maybe<Scalars["String"]>
    timezone?: Maybe<Scalars["String"]>
}

export type SalesByReportItem = {
    children?: Maybe<Array<SalesByReportItem>>
    id: Scalars["String"]
    name: Scalars["String"]
    quantity: Scalars["Int"]
    quantityPercentage: Scalars["Int"]
    quantityPercentageTotal: Scalars["Int"]
    revenue: Scalars["Int"]
    revenuePercentage: Scalars["Int"]
    revenuePercentageTotal: Scalars["Int"]
    type?: Maybe<Scalars["String"]>
    unit?: Maybe<Scalars["String"]>
    unitQuantity?: Maybe<Scalars["Int"]>
}

export type SalesInputFolder = {
    id: Scalars["String"]
    name: Scalars["String"]
    locationId: Scalars["String"]
    terminalId?: Maybe<Scalars["String"]>
    items: Array<SalesInputItem>
    hoursOfAvailability?: Maybe<TimeEntry>
    imageUrl?: Maybe<Scalars["String"]>
}

export type SalesInputItem = {
    id: Scalars["String"]
    separatorName?: Maybe<Scalars["String"]>
    categoryId?: Maybe<Scalars["String"]>
    sortIndex?: Maybe<Scalars["Int"]>
    folderId?: Maybe<Scalars["String"]>
    price?: Maybe<Array<Scalars["Int"]>>
    name?: Maybe<Scalars["String"]>
    description?: Maybe<Scalars["String"]>
    isActive?: Maybe<Scalars["Boolean"]>
    unit?: Maybe<Scalars["String"]>
}

export enum SalesInputSource {
    Mib = "mib",
    Kiosk = "kiosk",
}

export type SalesTaxReportResponse = {
    collectedTotal?: Maybe<Scalars["Int"]>
    grandTotal?: Maybe<Scalars["Int"]>
    cashTotal?: Maybe<Scalars["Int"]>
    cardTotal?: Maybe<Scalars["Int"]>
    otherTotal?: Maybe<Scalars["Int"]>
    rows: Array<SalesTaxReportRow>
}

export type SalesTaxReportRow = {
    name: Scalars["String"]
    rate?: Maybe<Scalars["Int"]>
    collected?: Maybe<Scalars["Int"]>
    total?: Maybe<Scalars["Int"]>
    cash?: Maybe<Scalars["Int"]>
    card?: Maybe<Scalars["Int"]>
    other?: Maybe<Scalars["Int"]>
}

export type SchematizedData = {
    layoutId: Scalars["String"]
    name: Scalars["String"]
    sortIndex: Scalars["Int"]
    size: SchematizedSize
    data: Array<SchematizedPageGroup>
}

export type SchematizedLayoutDeleteData = {
    layoutId: Scalars["String"]
    locationId: Scalars["String"]
}

export type SchematizedPage = {
    id: Scalars["String"]
    tiles: Array<SchematizedTile>
}

export type SchematizedPageGroup = {
    id: Scalars["String"]
    isRoot?: Maybe<Scalars["Boolean"]>
    pages: Array<SchematizedPage>
}

export type SchematizedPageGroupSaveData = {
    id: Scalars["String"]
    isRoot?: Maybe<Scalars["Boolean"]>
    pages: Array<SchematizedPageSaveData>
}

export type SchematizedPageSaveData = {
    id: Scalars["String"]
    tiles: Array<SchematizedTileSaveData>
}

export type SchematizedSaveData = {
    layoutId: Scalars["String"]
    name?: Maybe<Scalars["String"]>
    sortIndex?: Maybe<Scalars["Int"]>
    locationId: Scalars["String"]
    size: SchematizedSize
    data: Array<SchematizedPageGroupSaveData>
    auditData?: Maybe<AuditData>
}

export enum SchematizedSize {
    Medium = "Medium",
    Large = "Large",
}

export type SchematizedTile = {
    id: Scalars["String"]
    type: SchematizedTileType
    x: Scalars["Int"]
    y: Scalars["Int"]
    isSticky?: Maybe<Scalars["Boolean"]>
    targetPageGroupId?: Maybe<Scalars["String"]>
    categoryId?: Maybe<Scalars["String"]>
    customFolder?: Maybe<SchematizedTileCustomFolder>
}

export type SchematizedTileCustomFolder = {
    name?: Maybe<Scalars["String"]>
    icon?: Maybe<Scalars["Int"]>
    color?: Maybe<Scalars["String"]>
}

export type SchematizedTileCustomFolderSaveData = {
    name?: Maybe<Scalars["String"]>
    icon?: Maybe<Scalars["Int"]>
    color?: Maybe<Scalars["String"]>
}

export type SchematizedTileSaveData = {
    id: Scalars["String"]
    type: SchematizedTileType
    x: Scalars["Int"]
    y: Scalars["Int"]
    isSticky?: Maybe<Scalars["Boolean"]>
    targetPageGroupId?: Maybe<Scalars["String"]>
    categoryId?: Maybe<Scalars["String"]>
    customFolder?: Maybe<SchematizedTileCustomFolderSaveData>
}

export enum SchematizedTileType {
    ProductButton = "ProductButton",
    Folder = "Folder",
    BackButton = "BackButton",
}

export type ServiceDetail = {
    id: Scalars["String"]
    locationId: Scalars["String"]
    name: Scalars["String"]
    type: TerminalType
    isActive: Scalars["Boolean"]
    prefix?: Maybe<Scalars["String"]>
    kioskCustomerInstructions?: Maybe<Array<Scalars["String"]>>
    url?: Maybe<Scalars["String"]>
    aggregatorConfig?: Maybe<AggregatorConfig>
    metadata?: Maybe<ServiceMetadata>
    aggregatorType?: Maybe<AggregatorType>
    appVersion?: Maybe<Scalars["String"]>
}

export type ServiceFeeSettingsSaveRequest = {
    enabled?: Maybe<Scalars["Boolean"]>
    value?: Maybe<Scalars["Int"]>
    type?: Maybe<Scalars["String"]>
}

export type ServiceListItem = {
    id: Scalars["String"]
    locationId: Scalars["String"]
    isActive?: Maybe<Scalars["Boolean"]>
    name: Scalars["String"]
    type: TerminalType
    prefix?: Maybe<Scalars["String"]>
    url?: Maybe<Scalars["String"]>
    aggregatorConfig?: Maybe<AggregatorConfig>
    aggregatorType?: Maybe<AggregatorType>
    appVersion?: Maybe<Scalars["String"]>
    metadata?: Maybe<ServiceMetadata>
}

export type ServiceMetadata = {
    onlineOrdering?: Maybe<OnlineOrderingMetadata>
    KDS?: Maybe<KdsMetadata>
    POS?: Maybe<PosMetadata>
    OSB?: Maybe<OsbMetadata>
    kiosk?: Maybe<KioskMetadata>
    waitlist?: Maybe<WaitlistMetadata>
}

export type ServiceMetadataInput = {
    onlineOrdering?: Maybe<OnlineOrderingMetadataInput>
    KDS?: Maybe<KdsMetadataInput>
    POS?: Maybe<PosMetadataInput>
    OSB?: Maybe<OsbMetadataInput>
}

export type SettingsReponse = {
    delivery: DeliverySettingsResponse
    hoo: HooSettingsResponse
}

export type SettingsSaveRequest = {
    locationId?: Maybe<Scalars["String"]>
    terminalId?: Maybe<Scalars["String"]>
    deliverySettings?: Maybe<DeliverySettingsSaveRequest>
    hooSetttings?: Maybe<HooSettingsSaveRequest>
    auditData?: Maybe<AuditData>
}

export type SpecialPricingLogReportItem = {
    id: Scalars["String"]
    originTimestamp: Scalars["String"]
    orderNumber: Scalars["String"]
    assigneeName: Scalars["String"]
    adminName: Scalars["String"]
    terminalName?: Maybe<Scalars["String"]>
    pricingName: Scalars["String"]
    percentage?: Maybe<Scalars["Int"]>
    type: Scalars["String"]
    total: Scalars["Int"]
}

export type SpecialPricingReportRequestData = {
    from: Scalars["String"]
    to: Scalars["String"]
    location_ids?: Maybe<Scalars["String"]>
    timezone?: Maybe<Scalars["String"]>
}

export type SpecialPricingSummaryReportItem = {
    name: Scalars["String"]
    count: Scalars["Int"]
    total: Scalars["Int"]
    percentage?: Maybe<Scalars["Int"]>
    absolute?: Maybe<Scalars["Int"]>
    children?: Maybe<Array<SpecialPricingSummaryReportItem>>
}

export type SummaryNetCollectedBreakdownByEmployeeReportItem = {
    id?: Maybe<Scalars["String"]>
    firstName?: Maybe<Scalars["String"]>
    surname?: Maybe<Scalars["String"]>
    grossRevenueTotal?: Maybe<Scalars["Float"]>
    voidsTotal?: Maybe<Scalars["Float"]>
    refundsTotal?: Maybe<Scalars["Float"]>
    specialPricingsTotal?: Maybe<Scalars["Float"]>
    lossesTotal?: Maybe<Scalars["Float"]>
    forfeitedTotal?: Maybe<Scalars["Float"]>
    taxTotal?: Maybe<Scalars["Float"]>
    tipsTotal?: Maybe<Scalars["Float"]>
    total?: Maybe<Scalars["Float"]>
    children?: Maybe<Array<SummaryNetCollectedBreakdownByEmployeeReportItem>>
}

export type SummaryNetCollectedBreakdownByPaymentTypeReportItem = {
    paymentType?: Maybe<Scalars["String"]>
    grossRevenue: Scalars["Float"]
    refundsTotal: Scalars["Float"]
    cardSurcharge: Scalars["Float"]
    cashDiscount: Scalars["Float"]
    serviceFee: Scalars["Float"]
    voidsTotal: Scalars["Float"]
    specialPricings?: Maybe<Array<SummaryNetCollectedBreakdownSpecialPricingItem>>
    netRevenue: Scalars["Float"]
    taxes?: Maybe<Array<SummaryNetCollectedBreakdownTaxItem>>
    tipsTotal: Scalars["Float"]
    historicalRefunds: Scalars["Float"]
    futureRefunds: Scalars["Float"]
    netCollected: Scalars["Float"]
    losses: Scalars["Float"]
    forfeits: Scalars["Float"]
    gratuityTotal: Scalars["Float"]
    tipsAndGratuityTotal: Scalars["Float"]
    tips?: Maybe<Array<SummaryNetCollectedBreakdownTipItem>>
    children?: Maybe<Array<SummaryNetCollectedBreakdownByPaymentTypeReportItem>>
}

export type SummaryNetCollectedBreakdownReportItem = {
    grossRevenue: Scalars["Float"]
    refundsTotal: Scalars["Float"]
    cardSurcharge: Scalars["Float"]
    cashDiscount: Scalars["Float"]
    serviceFee: Scalars["Float"]
    voidsTotal: Scalars["Float"]
    specialPricings?: Maybe<Array<SummaryNetCollectedBreakdownSpecialPricingItem>>
    netRevenue: Scalars["Float"]
    taxes?: Maybe<Array<SummaryNetCollectedBreakdownTaxItem>>
    tipsTotal: Scalars["Float"]
    historicalRefunds: Scalars["Float"]
    futureRefunds: Scalars["Float"]
    netCollected: Scalars["Float"]
    losses: Scalars["Float"]
    forfeits: Scalars["Float"]
    gratuityTotal: Scalars["Float"]
    tipsAndGratuityTotal: Scalars["Float"]
    tips?: Maybe<Array<SummaryNetCollectedBreakdownTipItem>>
}

export type SummaryNetCollectedBreakdownSpecialPricingItem = {
    id: Scalars["String"]
    name: Scalars["String"]
    total: Scalars["Float"]
}

export type SummaryNetCollectedBreakdownTaxItem = {
    rowNumber: Scalars["String"]
    name: Scalars["String"]
    percentage?: Maybe<Scalars["String"]>
    total: Scalars["Float"]
}

export type SummaryNetCollectedBreakdownTipItem = {
    id: Scalars["String"]
    name: Scalars["String"]
    amountTip: Scalars["Float"]
}

export type SummaryNetCollectedByEmployeeReportItem = {
    id?: Maybe<Scalars["String"]>
    firstName?: Maybe<Scalars["String"]>
    surname?: Maybe<Scalars["String"]>
    cashTotal?: Maybe<Scalars["Float"]>
    cardTotal?: Maybe<Scalars["Float"]>
    externalTotal?: Maybe<Scalars["Float"]>
    total?: Maybe<Scalars["Float"]>
    redemptionTotal?: Maybe<Scalars["Float"]>
    children?: Maybe<Array<SummaryNetCollectedByEmployeeReportItem>>
}

export type SummaryNetCollectedBySourceReportItem = {
    id?: Maybe<Scalars["String"]>
    name?: Maybe<Scalars["String"]>
    count?: Maybe<Scalars["Float"]>
    countPercentage?: Maybe<Scalars["Float"]>
    total?: Maybe<Scalars["Float"]>
    totalPercentage?: Maybe<Scalars["Float"]>
    children?: Maybe<Array<SummaryNetCollectedBySourceReportItem>>
}

export type SummaryNetRevenueByAssignmentReportItem = {
    id?: Maybe<Scalars["String"]>
    name?: Maybe<Scalars["String"]>
    quantity?: Maybe<Scalars["Float"]>
    quantityPercentage?: Maybe<Scalars["Float"]>
    revenue?: Maybe<Scalars["Float"]>
    revenuePercentage?: Maybe<Scalars["Float"]>
    children?: Maybe<Array<SummaryNetRevenueByAssignmentReportItem>>
}

export type SummaryNetRevenueByCategoryReportItem = {
    id?: Maybe<Scalars["String"]>
    name?: Maybe<Scalars["String"]>
    type?: Maybe<Scalars["String"]>
    quantity?: Maybe<Scalars["Float"]>
    quantityPercentage?: Maybe<Scalars["Float"]>
    revenue?: Maybe<Scalars["Float"]>
    revenuePercentage?: Maybe<Scalars["Float"]>
    unit?: Maybe<Scalars["String"]>
    unitQuantity?: Maybe<Scalars["Float"]>
    children?: Maybe<Array<SummaryNetRevenueByCategoryReportItem>>
}

export type SummaryNetRevenueDailyItem = {
    date: Scalars["String"]
    netRevenueClosed: Scalars["Int"]
    netRevenueOpened: Scalars["Int"]
    orderCountOpened: Scalars["Int"]
}

export type SummaryNetRevenueHourlyItem = {
    createdOrders: Scalars["Int"]
    day: Scalars["Int"]
    hour: Scalars["Int"]
    openOrders: Scalars["Int"]
    revenueReceivable: Scalars["Int"]
    revenueReceived: Scalars["Int"]
    year: Scalars["Int"]
}

export type SummaryReportRequestData = {
    fromDate: Scalars["String"]
    toDate: Scalars["String"]
    locationIds?: Maybe<Array<Scalars["String"]>>
    assigneeIds?: Maybe<Array<Scalars["String"]>>
}

export type SummaryTransactionsByPaymentTypeReportItem = {
    name?: Maybe<Scalars["String"]>
    creditsCount?: Maybe<Scalars["Float"]>
    debitsCount?: Maybe<Scalars["Float"]>
    netCount?: Maybe<Scalars["Float"]>
    percentage?: Maybe<Scalars["Float"]>
    total?: Maybe<Scalars["Float"]>
    children?: Maybe<Array<SummaryTransactionsByPaymentTypeReportItem>>
}

export type Tax = {
    id: Scalars["String"]
    name: Scalars["String"]
    percentage?: Maybe<Scalars["Int"]>
    absolute?: Maybe<Scalars["Int"]>
    sortIndex: Scalars["Int"]
    locationsConfig: Array<TaxLocationConfig>
}

export type TaxLocationConfig = {
    locationId: Scalars["String"]
    isActive: Scalars["Boolean"]
    isAutoApply: Scalars["Boolean"]
    isEmbedded: Scalars["Boolean"]
}

export type Terminal = {
    id: Scalars["String"]
    locationId: Scalars["String"]
    isActive?: Maybe<Scalars["Boolean"]>
    name: Scalars["String"]
    type: TerminalType
    status: TerminalStatus
    prefix?: Maybe<Scalars["String"]>
    kioskCustomerInstructions?: Maybe<Array<Scalars["String"]>>
    slug?: Maybe<Scalars["String"]>
    domainName?: Maybe<Scalars["String"]>
    url?: Maybe<Scalars["String"]>
    metadata?: Maybe<ServiceMetadata>
    aggregatorConfig?: Maybe<AggregatorConfig>
    appVersion?: Maybe<Scalars["String"]>
}

export type TerminalAddRequestData = {
    id: Scalars["String"]
    isActive: Scalars["Boolean"]
    locationId: Scalars["String"]
    name: Scalars["String"]
    type: TerminalType
    metadata?: Maybe<ServiceMetadataInput>
}

export type TerminalAddResponseData = {
    terminalPrefix: Scalars["String"]
    slug?: Maybe<Scalars["String"]>
    status: TerminalStatus
}

export type TerminalDeactivateRequestData = {
    id: Scalars["String"]
    type: TerminalType
}

export enum TerminalStatus {
    New = "new",
    Active = "active",
    Inactive = "inactive",
}

export enum TerminalType {
    Register = "register",
    Kiosk = "kiosk",
    Mib = "mib",
    Kds = "kds",
    Aggregator = "aggregator",
    Pos = "pos",
    Osb = "osb",
    Mpos = "mpos",
    Figqr = "figqr",
    Waitlist = "waitlist",
}

export type TerminalUpdateRequestData = {
    id: Scalars["String"]
    isActive: Scalars["Boolean"]
    locationId: Scalars["String"]
    name?: Maybe<Scalars["String"]>
    type: TerminalType
    kioskCustomerInstructions?: Maybe<Array<Scalars["String"]>>
    aggregatorConfig?: Maybe<AggregatorConfigRequestData>
    metadata?: Maybe<ServiceMetadataInput>
    mibUrl?: Maybe<Scalars["String"]>
    auditData?: Maybe<AuditData>
}

export type TimeEntry = {
    id: Scalars["String"]
    name: Scalars["String"]
    timeSpans: Array<TimeSpan>
}

export type TimesheetRecord = {
    id: Scalars["String"]
    accountId: Scalars["String"]
    editorUserAccountId?: Maybe<Scalars["String"]>
    userAccountId?: Maybe<Scalars["String"]>
    employeeFullName?: Maybe<Scalars["String"]>
    roleName?: Maybe<Scalars["String"]>
    roleId: Scalars["String"]
    hourlyRate: Scalars["Int"]
    rateType?: Maybe<Scalars["String"]>
    clockInTimestamp: Scalars["String"]
    clockInTimezone?: Maybe<Scalars["String"]>
    clockInUserAccountId?: Maybe<Scalars["String"]>
    clockInLocationId: Scalars["String"]
    clockInTerminalId?: Maybe<Scalars["String"]>
    clockInTerminalName?: Maybe<Scalars["String"]>
    clockInLocationName?: Maybe<Scalars["String"]>
    clockOutTimestamp?: Maybe<Scalars["String"]>
    clockOutTimezone?: Maybe<Scalars["String"]>
    clockOutUserAccountId?: Maybe<Scalars["String"]>
    clockOutLocationId?: Maybe<Scalars["String"]>
    clockOutTerminalId?: Maybe<Scalars["String"]>
    clockOutTerminalName?: Maybe<Scalars["String"]>
    clockOutLocationName?: Maybe<Scalars["String"]>
    hasClockInImage: Scalars["Boolean"]
    hasClockOutImage: Scalars["Boolean"]
    lastUpdateTimestamp?: Maybe<Scalars["String"]>
    cost?: Maybe<Scalars["Float"]>
    duration?: Maybe<Scalars["Int"]>
    payableDuration?: Maybe<Scalars["Int"]>
    totalDuration?: Maybe<Scalars["Int"]>
    timezone?: Maybe<Scalars["String"]>
    breaks: Array<TimesheetRecordBreak>
}

export type TimesheetRecordBreak = {
    id: Scalars["String"]
    type: TimesheetRecordBreakType
    startTimestamp: Scalars["String"]
    endTimestamp?: Maybe<Scalars["String"]>
    duration?: Maybe<Scalars["Int"]>
    hasStartImage: Scalars["Boolean"]
    hasEndImage: Scalars["Boolean"]
}

export enum TimesheetRecordBreakType {
    Paid = "paid",
    Unpaid = "unpaid",
}

export type TimesheetReportGrandTotal = {
    userAccountId: Scalars["String"]
    cost: Scalars["Float"]
    duration: Scalars["Int"]
    payableDuration: Scalars["Int"]
    totalDuration: Scalars["Int"]
    paidBreaksDuration: Scalars["Int"]
    unpaidBreaksDuration: Scalars["Int"]
}

export type TimesheetsBreaksBreak = {
    id: Scalars["String"]
    type: TimesheetRecordBreakType
    shiftRoleName?: Maybe<Scalars["String"]>
    shiftStartTimestamp?: Maybe<Scalars["String"]>
    shiftStartTimezone?: Maybe<Scalars["String"]>
    shiftEndTimestamp?: Maybe<Scalars["String"]>
    shiftEndTimezone?: Maybe<Scalars["String"]>
    startTimestamp: Scalars["String"]
    endTimestamp?: Maybe<Scalars["String"]>
    duration?: Maybe<Scalars["Int"]>
    hasStartImage: Scalars["Boolean"]
    hasEndImage: Scalars["Boolean"]
    locationId: Scalars["String"]
    locationName?: Maybe<Scalars["String"]>
    timezone?: Maybe<Scalars["String"]>
}

export type TimesheetsBreaksInput = {
    dateFrom: Scalars["String"]
    dateTo: Scalars["String"]
    locationIds: Array<Scalars["String"]>
    employeeIds?: Maybe<Array<Scalars["String"]>>
}

export type TimesheetsBreaksRecord = {
    userAccountId: Scalars["String"]
    employeeFullName?: Maybe<Scalars["String"]>
    breaks: Array<TimesheetsBreaksBreak>
    totalDuration: Scalars["Int"]
}

export type TimesheetsInput = {
    dateFrom: Scalars["String"]
    dateTo: Scalars["String"]
    locationIds: Array<Scalars["String"]>
    employeeIds?: Maybe<Array<Scalars["String"]>>
    roleIds?: Maybe<Array<Scalars["String"]>>
}

export type TimesheetsLog = {
    id: Scalars["String"]
    editorId?: Maybe<Scalars["String"]>
    editorName?: Maybe<Scalars["String"]>
    employeeId: Scalars["String"]
    employeeName?: Maybe<Scalars["String"]>
    changeType: TimesheetsLogChangeType
    timeRecordId: Scalars["String"]
    before?: Maybe<TimesheetsLogChangeData>
    after?: Maybe<TimesheetsLogChangeData>
    createdTimestamp: Scalars["String"]
}

export type TimesheetsLogBreakData = {
    id: Scalars["String"]
    breakId: Scalars["String"]
    type?: Maybe<TimesheetsLogBreakType>
    startTimestamp?: Maybe<Scalars["String"]>
    endTimestamp?: Maybe<Scalars["String"]>
}

export enum TimesheetsLogBreakType {
    Paid = "paid",
    Unpaid = "unpaid",
}

export type TimesheetsLogChangeData = {
    roleId?: Maybe<Scalars["String"]>
    roleName?: Maybe<Scalars["String"]>
    hourlyRate?: Maybe<Scalars["String"]>
    rateType?: Maybe<Scalars["String"]>
    clockInTimestamp?: Maybe<Scalars["String"]>
    clockInLocationId?: Maybe<Scalars["String"]>
    clockInLocationName?: Maybe<Scalars["String"]>
    clockInTerminalId?: Maybe<Scalars["String"]>
    clockInTerminalName?: Maybe<Scalars["String"]>
    clockOutTimestamp?: Maybe<Scalars["String"]>
    clockOutLocationId?: Maybe<Scalars["String"]>
    clockOutLocationName?: Maybe<Scalars["String"]>
    clockOutTerminalId?: Maybe<Scalars["String"]>
    clockOutTerminalName?: Maybe<Scalars["String"]>
    breaks?: Maybe<Array<TimesheetsLogBreakData>>
}

export enum TimesheetsLogChangeType {
    ClockIn = "clockIn",
    ClockOut = "clockOut",
    Update = "update",
    Delete = "delete",
    Create = "create",
    BreakUpdate = "breakUpdate",
    BreakCreate = "breakCreate",
    BreakDelete = "breakDelete",
    BreakStart = "breakStart",
    BreakEnd = "breakEnd",
}

export type TimesheetsLogsInput = {
    locationIds: Array<Scalars["String"]>
    dateTo: Scalars["String"]
    dateFrom: Scalars["String"]
}

export type TimesheetsReport = {
    shifts: Array<TimesheetRecord>
    grandTotals: Array<TimesheetReportGrandTotal>
}

export type TimeSpan = {
    start: Scalars["String"]
    duration: Scalars["Int"]
    isExclusion: Scalars["Boolean"]
}

export type TimeSpanSaveRequestData = {
    start: Scalars["String"]
    duration: Scalars["Int"]
    isExclusion: Scalars["Boolean"]
}

export type TipsAndGratuityByAssignmentReportItem = {
    name?: Maybe<Scalars["String"]>
    columns?: Maybe<Array<TipsReportBreakdownColumn>>
    total?: Maybe<Scalars["Float"]>
    children?: Maybe<Array<TipsAndGratuityByAssignmentReportItem>>
}

export type TipsReportBreakdownColumn = {
    name?: Maybe<Scalars["String"]>
    total?: Maybe<Scalars["Float"]>
}

export type TransactionReportItem = {
    id: Scalars["String"]
    transactionNumber?: Maybe<Scalars["String"]>
    orderNumber?: Maybe<Scalars["String"]>
    currency?: Maybe<Scalars["String"]>
    paymentType?: Maybe<Scalars["String"]>
    transactorName?: Maybe<Scalars["String"]>
    assigneeId?: Maybe<Scalars["String"]>
    assigneeName?: Maybe<Scalars["String"]>
    operation?: Maybe<Scalars["String"]>
    entryMode?: Maybe<Scalars["String"]>
    total?: Maybe<Scalars["Int"]>
    result?: Maybe<Scalars["String"]>
    resultMessage?: Maybe<Scalars["String"]>
    initiatedOffline?: Maybe<Scalars["Boolean"]>
    approvalCode?: Maybe<Scalars["String"]>
    terminalId?: Maybe<Scalars["String"]>
    terminalName?: Maybe<Scalars["String"]>
    locationId?: Maybe<Scalars["String"]>
    locationName?: Maybe<Scalars["String"]>
    paymentSubtype?: Maybe<Scalars["String"]>
    externalPaymentType?: Maybe<Scalars["String"]>
    timestamp?: Maybe<Scalars["String"]>
}

export type TransactionReportResponse = {
    data: Array<TransactionReportItem>
    totalCount: Scalars["Int"]
}

export type UberStore = {
    storeId: Scalars["String"]
    name: Scalars["String"]
}

export type UberStoreResponse = {
    uberAuth?: Maybe<OAuthTokens>
    stores: Array<UberStore>
}

export type VoidsLogReportItem = {
    id: Scalars["String"]
    accountId: Scalars["String"]
    amount: Scalars["Int"]
    approvalName: Scalars["String"]
    assigneeName: Scalars["String"]
    content: Scalars["String"]
    locationName: Scalars["String"]
    originTimestamp: Scalars["String"]
    entityNumber?: Maybe<Scalars["String"]>
    terminalName?: Maybe<Scalars["String"]>
    reasonCode?: Maybe<Scalars["String"]>
}

export type VoidsSummaryReportItem = {
    row_number?: Maybe<Scalars["Int"]>
    account_id?: Maybe<Scalars["String"]>
    type?: Maybe<Scalars["String"]>
    item_name?: Maybe<Scalars["String"]>
    reason_code?: Maybe<Scalars["String"]>
    quantity?: Maybe<Scalars["Int"]>
    amount?: Maybe<Scalars["Int"]>
}

export type WaitlistMetadata = {
    id: Scalars["String"]
    selfEnrollment: Scalars["Boolean"]
    confirmationRequired: Scalars["Boolean"]
    selfEnrollmentAvailability: Scalars["Int"]
    gracePeriod: Scalars["Int"]
    minPartySize: Scalars["Int"]
    maxPartySize: Scalars["Int"]
}

export type WestSideEatsConfig = {
    apiKey: Scalars["String"]
}
